import { parseImmo } from '../util/immoObjectParser';
import { dummymakler4 } from './demo_makler';

export const abgeberimmo_phase2 = {
  id: 14512875,
  tenant_id: 960,
  created_at: '2025-03-04T10:06:22+01:00',
  updated_at: '2025-03-20T12:56:09+01:00',
  published_at: '2025-03-20T12:55:35+01:00',
  catalogue_number: {
    plain: 71127,
    display: '960/71127',
  },
  status: {
    id: 5,
    name: 'aktiv',
    until: null,
  },
  address: {
    street: null,
    number: null,
    entrance: null,
    door: null,
    zip: null,
    city: null,
    floor: null,
    country: null,
    geo_coordinates: null,
  },
  public_address: {
    street: null,
    number: null,
    entrance: null,
    door: null,
    zip: '1030',
    city: 'Wien',
    country: 'AT',
    geo_coordinates: {
      latitude: 48.2017333,
      longitude: 16.3916496,
    },
    fuzzy_geo_coordinates: {
      latitude: 48.1980826,
      longitude: 16.39832571,
      radius: 255,
    },
  },
  land_registry_number: null,
  cadastral_municipality: null,
  plot_number: null,
  system_type: 0,
  parent_id: null,
  type: {
    id: 2,
    name: 'Wohnung',
    openimmo_key: 'wohnung',
  },
  subtype: null,
  occupancy: {
    residential: true,
    commercial: false,
    investment: false,
  },
  marketing_type: 0,
  architecture: null,
  'year_of_export construction': null,
  infrastructure_provision: null,
  year_of_last_renovation: null,
  areas: {
    site_area: null,
    living_area: {
      area: 90,
    },
    floor_area: null,
    developable_area: null,
    office_area: null,
    sales_area: null,
    storage_area: null,
    available_area: null,
    short_term_area: null,
    total_area: null,
    weighted_area: null,
    undeveloped_attic_area: null,
    garden_area: null,
    basement_area: null,
    balcony_area: null,
    terrace_area: null,
    covered_balcony_area: null,
    garage_area: null,
    parking_space_area: null,
  },
  rooms: {
    rooms: 3,
    toilets: null,
    bathrooms: null,
    storerooms: null,
  },
  prices: {
    publish_prices: true,
    purchase_price: {
      currency: 'EUR',
      net: 600000,
      gross: 600000,
      vat_absolute: 0,
      vat_percentage: 0,
    },
    rent: null,
    furniture_hire: {
      currency: 'EUR',
      net: 0,
      gross: 0,
      vat_absolute: 0,
      vat_percentage: 0,
    },
    parking: {
      currency: 'EUR',
      net: 0,
      gross: 0,
      vat_absolute: 0,
      vat_percentage: 0,
    },
    garage: {
      currency: 'EUR',
      net: 0,
      gross: 0,
      vat_absolute: 0,
      vat_percentage: 0,
    },
    operating: {
      currency: 'EUR',
      net: 0,
      gross: 0,
      vat_absolute: 0,
      vat_percentage: 0,
    },
    heating: {
      currency: 'EUR',
      net: 0,
      gross: 0,
      vat_absolute: 0,
      vat_percentage: 0,
    },
    hot_water: {
      currency: 'EUR',
      net: 0,
      gross: 0,
      vat_absolute: 0,
      vat_percentage: 0,
    },
    cooling: {
      currency: 'EUR',
      net: 0,
      gross: 0,
      vat_absolute: 0,
      vat_percentage: 0,
    },
    maintenance_funds: {
      currency: 'EUR',
      net: 0,
      gross: 0,
      vat_absolute: 0,
      vat_percentage: 0,
    },
    elevator: {
      currency: 'EUR',
      net: 0,
      gross: 0,
      vat_absolute: 0,
      vat_percentage: 0,
    },
    others: {
      currency: 'EUR',
      net: 0,
      gross: 0,
      vat_absolute: 0,
      vat_percentage: 0,
    },
  },
  earnings_per_year: {
    currency: 'EUR',
    net: 0,
  },
  obtainable_from: {
    date: '0001-01-01T00:00:00+00:00',
    text: '',
  },
  preview_image: {
    storage_key: '4UtsXe59QL4GqUU3DYOnn4.jpeg',
    sizes: {
      original: [],
      fm_small: [],
      medium: [],
    },
  },
  categories: [],
  custom_fields: [
    {
      type: 0,
      name: 'custom_1',
      value:
        '\u003Ch1\u003E3.,\u00A0Moderne 3-Zimmer Wohnung mit exklusiver Ausstattung\u003C/h1\u003E\r\n\r\n\u003Cp\u003EWfl. ca. 90 m\u00B2, 3 Zimmer, Einbauk\u00FCche, Bad mit Dusche, Balkon, Stadtblick, edles Parkett, Fu\u00DFbodenheizung, Parkplatz, Keller, hervorragende \u00F6ffentliche Anbindung.\u00A0\u003C/p\u003E\r\n\r\n\u003Cp\u003E\u00A0\u003C/p\u003E\r\n\r\n\u003Cp\u003E\u00A0\u003C/p\u003E',
      locale: 'de',
    },
  ],
  agent: {
    id: 16473959,
    prefix: '',
    first_name: dummymakler4.firstName,
    last_name: dummymakler4.lastName,
    gender: 1,
    suffix: '',
    email: `${dummymakler4.firstName.toLowerCase()}.${dummymakler4.lastName.toLowerCase()}@sreal.at`,
    phone: '\u002B43 664 6294547',
    phone_business: '\u002B43 (0)5 0100 - 26238',
    phone_mobile: '\u002B43 664 6294547',
    profile_picture: {
      storage_key: dummymakler4.profilePictureFileId,
      filename: dummymakler4.profilePictureFileId,
      title: null,
    },
    immobiliencard_id: '',
    immobiliencard_uid: null,
    foreign_id: 33980,
    role: 0,
    permissions: null,
    tenant: {
      id: 960,
      name: 's REAL Immobilienvermittlung GmbH',
      email: 'kundenbetreuung@sreal.at',
      phone: '',
      address: {
        street: 'Landstra\u00DFer Hauptstra\u00DFe 60',
        zip: '1030',
        city: 'Wien',
        country: 'AT',
      },
    },
  },
  active_for_export: true,
  accessible: false,
  contacts: [
    {
      role: 1,
      prospect_state: 0,
      contact: {
        id: 38077701,
        created_at: '2025-03-04T10:01:48+01:00',
        updated_at: '2025-03-17T11:46:00+01:00',
      },
    },
  ],
  files: [
    {
      type: 0,
      storage_key: '4UtsXe59QL4GqUU3DYOnn4.jpeg',
      url: 'https://storage.justimmo.at/file/4UtsXe59QL4GqUU3DYOnn4.jpeg',
      original_filename: 'Wohnk\u00FCche.jpeg',
      title: '',
      description: '',
      sort_order: 0,
      uploaded_at: '2025-03-17T12:46:00+01:00',
      visibility: 0,
      active: true,
      group: {
        id: 1,
      },
      original_filesize: 590730,
      mime_type: 'image/jpeg',
      width: 1792,
      height: 1024,
      thumbnails: [
        {
          name: 'small',
          url: 'https://storage.justimmo.at/thumb/e1405fd1968955e5c56b7c6d5403feba/fc_h300_w100/4UtsXe59QL4GqUU3DYOnn4.jpeg',
        },
        {
          name: 'fullhd',
          url: 'https://storage.justimmo.at/thumb/093970f5d0dc8b905caa016a5dc0b812/fc_h1080_w1920/4UtsXe59QL4GqUU3DYOnn4.jpeg',
        },
        {
          name: 'fullhd_branded',
          url: 'https://storage.justimmo.at/thumb/6ef47aadaf35782beed26ba275fb7326/Fc_Ltl_Ms58xncItneAknwZKGdek0.png_fc_h1080_w1920/4UtsXe59QL4GqUU3DYOnn4.jpeg',
        },
      ],
    },
    {
      type: 0,
      storage_key: '3aNkfgFFyMOrhDloLjmqRd.jpeg',
      url: 'https://storage.justimmo.at/file/3aNkfgFFyMOrhDloLjmqRd.jpeg',
      original_filename: 'Vorzimmer.jpeg',
      title: '',
      description: '',
      sort_order: 5,
      uploaded_at: '2025-03-17T12:46:00+01:00',
      visibility: 0,
      active: true,
      group: {
        id: 1,
      },
      original_filesize: 477626,
      mime_type: 'image/jpeg',
      width: 1792,
      height: 1024,
      thumbnails: [
        {
          name: 'small',
          url: 'https://storage.justimmo.at/thumb/b3db8e4e36565553990d40f6bc3ddd41/fc_h300_w100/3aNkfgFFyMOrhDloLjmqRd.jpeg',
        },
        {
          name: 'fullhd',
          url: 'https://storage.justimmo.at/thumb/269ed7f42270cb345bb82c16fec9cd73/fc_h1080_w1920/3aNkfgFFyMOrhDloLjmqRd.jpeg',
        },
        {
          name: 'fullhd_branded',
          url: 'https://storage.justimmo.at/thumb/b729317e02681d767048d5888c0982de/Fc_Ltl_Ms58xncItneAknwZKGdek0.png_fc_h1080_w1920/3aNkfgFFyMOrhDloLjmqRd.jpeg',
        },
      ],
    },
    {
      type: 0,
      storage_key: '5Ofhx5nCAAnVuXhTUZvECP.jpeg',
      url: 'https://storage.justimmo.at/file/5Ofhx5nCAAnVuXhTUZvECP.jpeg',
      original_filename: 'Balkon.jpeg',
      title: '',
      description: '',
      sort_order: 1,
      uploaded_at: '2025-03-17T12:45:59+01:00',
      visibility: 0,
      active: true,
      group: {
        id: 1,
      },
      original_filesize: 509662,
      mime_type: 'image/jpeg',
      width: 1792,
      height: 1024,
      thumbnails: [
        {
          name: 'small',
          url: 'https://storage.justimmo.at/thumb/4874f7d9320a9888c20fc02e665cdf9b/fc_h300_w100/5Ofhx5nCAAnVuXhTUZvECP.jpeg',
        },
        {
          name: 'fullhd',
          url: 'https://storage.justimmo.at/thumb/53505fe81ea80647391caa2d39dc6aa2/fc_h1080_w1920/5Ofhx5nCAAnVuXhTUZvECP.jpeg',
        },
        {
          name: 'fullhd_branded',
          url: 'https://storage.justimmo.at/thumb/95e803ba17d328f35ef64002bf935c36/Fc_Ltl_Ms58xncItneAknwZKGdek0.png_fc_h1080_w1920/5Ofhx5nCAAnVuXhTUZvECP.jpeg',
        },
      ],
      additionalProperties: {},
    },
    {
      type: 0,
      storage_key: '4QY4bsiMfX2IfYovORhe6a.jpeg',
      url: 'https://storage.justimmo.at/file/4QY4bsiMfX2IfYovORhe6a.jpeg',
      original_filename: 'Schlafzimmer.jpeg',
      title: '',
      description: '',
      sort_order: 2,
      uploaded_at: '2025-03-17T12:45:59+01:00',
      visibility: 0,
      active: true,
      group: {
        id: 1,
      },
      original_filesize: 462876,
      mime_type: 'image/jpeg',
      width: 1792,
      height: 1024,
      thumbnails: [
        {
          name: 'small',
          url: 'https://storage.justimmo.at/thumb/ff3a798b7eef58cd71823ab97d3af898/fc_h300_w100/4QY4bsiMfX2IfYovORhe6a.jpeg',
        },
        {
          name: 'fullhd',
          url: 'https://storage.justimmo.at/thumb/c893f5a02395f4851d434ce4025510de/fc_h1080_w1920/4QY4bsiMfX2IfYovORhe6a.jpeg',
        },
        {
          name: 'fullhd_branded',
          url: 'https://storage.justimmo.at/thumb/8f02816357ea053a684e3e6e6c43a627/Fc_Ltl_Ms58xncItneAknwZKGdek0.png_fc_h1080_w1920/4QY4bsiMfX2IfYovORhe6a.jpeg',
        },
      ],
      additionalProperties: {},
    },
    {
      type: 0,
      storage_key: '5JMhDRPT70VZS12rO95s30.jpeg',
      url: 'https://storage.justimmo.at/file/5JMhDRPT70VZS12rO95s30.jpeg',
      original_filename: 'Arbeits- und G\u00E4stezimmer.jpeg',
      title: '',
      description: '',
      sort_order: 3,
      uploaded_at: '2025-03-17T12:45:58+01:00',
      visibility: 0,
      active: true,
      group: {
        id: 1,
      },
      original_filesize: 501991,
      mime_type: 'image/jpeg',
      width: 1792,
      height: 1024,
      thumbnails: [
        {
          name: 'small',
          url: 'https://storage.justimmo.at/thumb/805579be7aa5d13313715c4ca4eb48c2/fc_h300_w100/5JMhDRPT70VZS12rO95s30.jpeg',
        },
        {
          name: 'fullhd',
          url: 'https://storage.justimmo.at/thumb/b2019bd892af30bddb700fd1e9da8bec/fc_h1080_w1920/5JMhDRPT70VZS12rO95s30.jpeg',
        },
        {
          name: 'fullhd_branded',
          url: 'https://storage.justimmo.at/thumb/165a2f3ac73c9ba8f14287789c7797c6/Fc_Ltl_Ms58xncItneAknwZKGdek0.png_fc_h1080_w1920/5JMhDRPT70VZS12rO95s30.jpeg',
        },
      ],
      additionalProperties: {},
    },
    {
      type: 0,
      storage_key: '7CAtLFUNW9aNSxoudE2v1M.jpeg',
      url: 'https://storage.justimmo.at/file/7CAtLFUNW9aNSxoudE2v1M.jpeg',
      original_filename: 'Badezimmer.jpeg',
      title: '',
      description: '',
      sort_order: 4,
      uploaded_at: '2025-03-17T12:45:58+01:00',
      visibility: 0,
      active: true,
      group: {
        id: 1,
      },
      original_filesize: 471043,
      mime_type: 'image/jpeg',
      width: 1792,
      height: 1024,
      thumbnails: [
        {
          name: 'small',
          url: 'https://storage.justimmo.at/thumb/b4d03e38efcde10e188175adcb781257/fc_h300_w100/7CAtLFUNW9aNSxoudE2v1M.jpeg',
        },
        {
          name: 'fullhd',
          url: 'https://storage.justimmo.at/thumb/1186d25b792baf0e60e677e08cda193a/fc_h1080_w1920/7CAtLFUNW9aNSxoudE2v1M.jpeg',
        },
        {
          name: 'fullhd_branded',
          url: 'https://storage.justimmo.at/thumb/c3ee48fa8e356c25980548927811b5c3/Fc_Ltl_Ms58xncItneAknwZKGdek0.png_fc_h1080_w1920/7CAtLFUNW9aNSxoudE2v1M.jpeg',
        },
      ],
      additionalProperties: {},
    },
    {
      type: 0,
      storage_key: '2zineWGEg1ZLSxYvLuwwbZ.jpg',
      url: 'https://storage.justimmo.at/file/2zineWGEg1ZLSxYvLuwwbZ.jpg',
      original_filename: 'Plan.jpg',
      title: 'Plan',
      description: '',
      sort_order: 0,
      uploaded_at: '2025-03-15T09:03:16+01:00',
      visibility: 0,
      active: true,
      group: {
        id: 2,
      },
      original_filesize: 506317,
      mime_type: 'image/jpeg',
      width: 2475,
      height: 3500,
      thumbnails: [
        {
          name: 'small',
          url: 'https://storage.justimmo.at/thumb/2540ce2ea2fe599faa7a53607d1e4710/fc_h300_w100/2zineWGEg1ZLSxYvLuwwbZ.jpg',
        },
        {
          name: 'fullhd',
          url: 'https://storage.justimmo.at/thumb/c8dc83b31eea888402751a6f56da8c31/fc_h1080_w1920/2zineWGEg1ZLSxYvLuwwbZ.jpg',
        },
        {
          name: 'fullhd_branded',
          url: 'https://storage.justimmo.at/thumb/52a959fbbd6faa57019857706054c282/Fc_Ltl_Ms58xncItneAknwZKGdek0.png_fc_h1080_w1920/2zineWGEg1ZLSxYvLuwwbZ.jpg',
        },
      ],
      additionalProperties: {},
    },
    {
      type: 0,
      storage_key: '3dNiKBVWrudeDSxuqNPE57.png',
      url: 'https://storage.justimmo.at/file/3dNiKBVWrudeDSxuqNPE57.png',
      original_filename: 'Lageplan.png',
      title: '',
      description: '',
      sort_order: 1,
      uploaded_at: '2025-03-04T10:32:01+01:00',
      visibility: 0,
      active: true,
      group: {
        id: 2,
      },
      original_filesize: 571116,
      mime_type: 'image/png',
      width: 2048,
      height: 1360,
      thumbnails: [
        {
          name: 'small',
          url: 'https://storage.justimmo.at/thumb/eb2640f9d36e5478da4495921e834636/fc_h300_w100/3dNiKBVWrudeDSxuqNPE57.png',
        },
        {
          name: 'fullhd',
          url: 'https://storage.justimmo.at/thumb/fa85dc78fcca559e5aa7b29e84031e8d/fc_h1080_w1920/3dNiKBVWrudeDSxuqNPE57.png',
        },
        {
          name: 'fullhd_branded',
          url: 'https://storage.justimmo.at/thumb/c91b34ed14500e4c001dcf55534d67a8/Fc_Ltl_Ms58xncItneAknwZKGdek0.png_fc_h1080_w1920/3dNiKBVWrudeDSxuqNPE57.png',
        },
      ],
      additionalProperties: {},
    },
  ],
  internal_files: [],
  texts: {
    label: '',
    title: [
      {
        value: 'Moderne 3-Zimmer Wohnung mit exklusiver Ausstattung',
        locale: 'de',
        additionalProperties: {},
      },
    ],
    location: [
      {
        value: 'Diese wundersch\u00F6ne, m\u00F6blierte Wohnung befindet sich im 3. Bezirk in der N\u00E4he des Wiener Praters und \u00FCberzeugt durch ihre hervorragende Lage.',
        locale: 'de',
        additionalProperties: {},
      },
    ],
    description: [
      {
        value:
          '\u003Cp\u003EWillkommen in Ihrem neuen Zuhause im Herzen von 1030 Wien! Diese beeindruckende Wohnung bietet Ihnen nicht nur eine erstklassige Lage, sondern auch eine F\u00FClle an Annehmlichkeiten, die das Leben in der Stadt so angenehm machen.\u003C/p\u003E\r\n\r\n\u003Cp\u003EMit einer gro\u00DFz\u00FCgigen Fl\u00E4che von 90 m\u00B2 und drei gut geschnittenen Zimmern ist diese Immobilie der ideale R\u00FCckzugsort f\u00FCr Familien, Paare oder alle, die viel Platz und Komfort sch\u00E4tzen. Der traumhafte Stadtblick von Ihrem S\u00FCdwestbalkon wird Sie t\u00E4glich begeistern und l\u00E4dt dazu ein, den Abend bei einem Glas Wein ausklingen zu lassen.\u003C/p\u003E\r\n\r\n\u003Cp\u003EDie Wohnung wurde mit hochwertigen Materialien ausgestattet, darunter edles Parkett und eine moderne Fu\u00DFbodenheizung, die f\u00FCr ein behagliches Wohnklima sorgt. Die offene Einbauk\u00FCche ist nicht nur funktional, sondern auch ein stilvoller Mittelpunkt, der das Kochen zu einem Vergn\u00FCgen macht. Ob Sie ein schnelles Fr\u00FChst\u00FCck zubereiten oder ein ausgiebiges Dinner f\u00FCr Freunde planen \u2013 hier wird jeder Moment zum Erlebnis.\u003C/p\u003E\r\n\r\n\u003Cp\u003EDie hervorragende Verkehrsanbindung in der Umgebung ist ein weiterer Pluspunkt dieser Immobilie. Mit Bus, U-Bahn, Stra\u00DFenbahn und dem Bahnhof in unmittelbarer N\u00E4he sind Sie optimal vernetzt und gelangen schnell an Ihr Ziel \u2013 sei es zur Arbeit, zum Einkaufen oder zu Freizeitaktivit\u00E4ten.\u00A0\u003C/p\u003E\r\n\r\n\u003Cp\u003EDie Nachbarschaft bietet Ihnen alles, was Sie f\u00FCr den t\u00E4glichen Bedarf ben\u00F6tigen. \u00C4rzte, Apotheken, Kliniken und Krankenh\u00E4user sind in der N\u00E4he, ebenso wie Schulen, Kinderg\u00E4rten und Universit\u00E4ten. Superm\u00E4rkte, B\u00E4ckereien und ein Einkaufszentrum befinden sich ebenfalls in der Umgebung, sodass Sie in k\u00FCrzester Zeit alles erreichen k\u00F6nnen, was Sie ben\u00F6tigen.\u003C/p\u003E\r\n\r\n\u003Cp\u003ELassen Sie sich diese einmalige Gelegenheit nicht entgehen! Diese Wohnung ist mehr als nur ein Ort zum Wohnen \u2013 sie ist ein Lebensraum, der Ihnen Komfort, Stil und eine ausgezeichnete Lebensqualit\u00E4t bietet. Kontaktieren Sie uns noch heute f\u00FCr einen Besichtigungstermin und \u00FCberzeugen Sie sich selbst von diesem wunderbaren Angebot in 1030 Wien!\u003C/p\u003E',
        locale: 'de',
        additionalProperties: {},
      },
    ],
    description_expose: [],
    additionalProperties: {},
  },
  energy_performance_certification: {
    energy_performance: {
      value: 1.83,
      class: 1,
      additionalProperties: {},
    },
    heating_demand: {
      value: 33.3,
      class: 2,
      additionalProperties: {},
    },
    valid_until: '2028-01-13T00:00:00+00:00',
    auto_disclaimer: false,
    additionalProperties: {},
  },
  features: [
    {
      group_label: 'Boden',
      items: [
        {
          id: 7,
          label: 'Parkett',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      group_label: 'Heizungsart',
      items: [
        {
          id: 18,
          label: 'Fu\u00DFbodenheizung',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      group_label: 'K\u00FCche',
      items: [
        {
          id: 22,
          label: 'Einbauk\u00FCche',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      group_label: 'Fahrstuhl',
      items: [
        {
          id: 25,
          label: 'Personenaufzug',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      group_label: 'Bad',
      items: [
        {
          id: 35,
          label: 'Dusche',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      group_label: 'Stellplatzart',
      items: [
        {
          id: 46,
          label: 'Parkplatz',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      group_label: 'Balkon',
      items: [
        {
          id: 106,
          label: 'S\u00FCdwestbalkon / -terrasse',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      group_label: 'Ausblick',
      items: [
        {
          id: 664,
          label: 'Stadtblick',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      group_label: 'Bauweise',
      items: [
        {
          id: 945,
          label: 'Ziegel',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
  ],
  links: [],
  residential_aggregation_data: null,
  commission: {
    prospect: {
      text_value: '3% des Kaufpreises zzgl. 20% USt.',
    },
  },
  condition_assessment: null,
  is_public: true,
  agency_agreement: {
    valid_from: null,
    valid_until: null,
    agency_agreement_type: 0,
    agreement_method: null,
    additionalProperties: {
      business_opportunity_knowledge_date: null,
    },
  },
  additionalProperties: {
    284621766:
      '{"ActivityTypeId":4,"ActivityTypeName":"E-Mail (Angebot via Justimmo)","Comment":"mit Adressen, mit Preisen, mit Links, mit folgenden Dateien: \\u0022960-71130_-_Wohnung_-_Kauf_-_1030_-_Expose\\u0022, \\u00222024_04_Maklervertrag und AGB.pdf\\u0022, Kaufpreis: 1.990.000,00\\u00A0\\u20AC","Created_at":"2025-03-12T14:26:56+01:00","Offertext":"\\u003Ch2\\u003ESehr geehrte(r) Frau/Herr Mustermann!\\u003C/h2\\u003E\\u003Ch2\\u003EHiermit \\u00FCbermitteln wir Ihnen ein Immobilienangebot.\\u003C/h2\\u003E\\u003Cp\\u003E\\u00DCber den Button \\u201EZum Immobilienangebot gelangen Sie direkt zur Detailseite, auf der Sie weitere Informationen sowie alle relevanten Dokumente, wie das Immobilienexpos\\u00E9, herunterladen k\\u00F6nnen. Bei Fragen steht Ihnen die dort genannte Immobilienmakler:in gerne zur Verf\\u00FCgung.\\u003C/p\\u003E\\u003Cp\\u003Ehttps://apps.justimmo.at/nachricht/27365139/29704465/82904b32524355aff3fc0533f72a09b9f20fc6f4/immobilie\\u003C/p\\u003E","Files":[{"Type":1,"Storage_key":"3o9Ba5p5iBgSKZhVeVeVoH.pdf","Url":"https://api.justimmo.at/v1/file/3o9Ba5p5iBgSKZhVeVeVoH.pdf","Original_filename":"960-71130_-_Wohnung_-_Kauf_-_1030_-_Expose.pdf","Title":"960-71130_-_Wohnung_-_Kauf_-_1030_-_Expose","Description":"","Sort_order":null,"Uploaded_at":"2025-03-12T14:26:59+01:00","Visibility":1,"Active":true,"Group":null,"Original_filesize":9992741,"Mime_type":"application/pdf","Width":0,"Height":0,"Thumbnails":null,"AdditionalProperties":{}},{"Type":1,"Storage_key":"2ZSazQaCQ6lS3HejGtfdjk.pdf","Url":"https://storage.justimmo.at/file/2ZSazQaCQ6lS3HejGtfdjk.pdf","Original_filename":"2024_04_Maklervertrag und AGB.pdf","Title":"","Description":"","Sort_order":null,"Uploaded_at":"2025-02-17T09:26:51+01:00","Visibility":0,"Active":true,"Group":null,"Original_filesize":106852,"Mime_type":"application/pdf","Width":0,"Height":0,"Thumbnails":null,"AdditionalProperties":{}}],"From":"0001-01-01 00:00:00Z","To":"0001-01-01 00:00:00Z"}',
    284621781:
      '{"ActivityTypeId":4,"ActivityTypeName":"E-Mail (Angebot via Justimmo)","Comment":"mit Adressen, mit Preisen, mit Links, mit folgenden Dateien: \\u0022960-71130_-_Wohnung_-_Kauf_-_1030_-_Expose\\u0022, \\u00222024_04_Maklervertrag und AGB.pdf\\u0022, Kaufpreis: 1.990.000,00\\u00A0\\u20AC","Created_at":"2025-03-12T14:27:02+01:00","Offertext":"\\u003Ch2\\u003ESehr geehrter Herr Mustermann!\\u003C/h2\\u003E\\u003Ch2\\u003EHiermit \\u00FCbermitteln wir Ihnen ein Immobilienangebot.\\u003C/h2\\u003E\\u003Cp\\u003E\\u00DCber den Button \\u201EZum Immobilienangebot gelangen Sie direkt zur Detailseite, auf der Sie weitere Informationen sowie alle relevanten Dokumente, wie das Immobilienexpos\\u00E9, herunterladen k\\u00F6nnen. Bei Fragen steht Ihnen die dort genannte Immobilienmakler:in gerne zur Verf\\u00FCgung.\\u003C/p\\u003E\\u003Cp\\u003Ehttps://apps.justimmo.at/nachricht/27365139/33107941/abf4b17a4b1084ace6b5276f7e4c1b5e99e920fb/immobilie\\u003C/p\\u003E","Files":[{"Type":1,"Storage_key":"49xHDkgPggg4YKUjCcQVbn.pdf","Url":"https://api.justimmo.at/v1/file/49xHDkgPggg4YKUjCcQVbn.pdf","Original_filename":"960-71130_-_Wohnung_-_Kauf_-_1030_-_Expose.pdf","Title":"960-71130_-_Wohnung_-_Kauf_-_1030_-_Expose","Description":"","Sort_order":null,"Uploaded_at":"2025-03-12T14:27:04+01:00","Visibility":1,"Active":true,"Group":null,"Original_filesize":9992717,"Mime_type":"application/pdf","Width":0,"Height":0,"Thumbnails":null,"AdditionalProperties":{}},{"Type":1,"Storage_key":"2ZSazQaCQ6lS3HejGtfdjk.pdf","Url":"https://storage.justimmo.at/file/2ZSazQaCQ6lS3HejGtfdjk.pdf","Original_filename":"2024_04_Maklervertrag und AGB.pdf","Title":"","Description":"","Sort_order":null,"Uploaded_at":"2025-02-17T09:26:51+01:00","Visibility":0,"Active":true,"Group":null,"Original_filesize":106852,"Mime_type":"application/pdf","Width":0,"Height":0,"Thumbnails":null,"AdditionalProperties":{}}],"From":"0001-01-01 00:00:00Z","To":"0001-01-01 00:00:00Z"}',
    284623371:
      '{"ActivityTypeId":4,"ActivityTypeName":"E-Mail (Angebot via Justimmo)","Comment":"Preisreduktion - E-Mail Anbot / , mit Adressen, mit Preisen, mit folgenden Dateien: \\u0022960-71130_-_Wohnung_-_Kauf_-_1030_-_Expose\\u0022, \\u00222024_04_Maklervertrag und AGB.pdf\\u0022, Kaufpreis: 1.990.000,00\\u00A0\\u20AC","Created_at":"2025-03-12T14:36:29+01:00","Offertext":"\\u003Cp\\u003E\\u003Cspan style=\\u0022font-size:14px;\\u0022\\u003ESehr geehrte(r) Frau/Herr Mustermann,\\u003C/span\\u003E\\u003C/p\\u003E\\u003Cp\\u003Ewir erlauben uns, Sie \\u00FCber die Preisreduktion dieser Immobilie zu informieren.\\u003C/p\\u003E\\u003Cp\\u003EDas Expos\\u00E9 mit dem aktuellen Preis finden Sie im Anhang.\\u003C/p\\u003E\\u003Cp\\u003EF\\u00FCr weitere Fragen stehen wir Ihnen gerne zur Verf\\u00FCgung!\\u003C/p\\u003E\\u003Cp\\u003Ehttps://apps.justimmo.at/nachricht/27365352/29891197/54156820b4b1a2e367b940f9f595692cf821f270/immobilie\\u003C/p\\u003E","Files":[{"Type":1,"Storage_key":"21ZRzMVj8uhDs2eLkA4TnZ.pdf","Url":"https://api.justimmo.at/v1/file/21ZRzMVj8uhDs2eLkA4TnZ.pdf","Original_filename":"960-71130_-_Wohnung_-_Kauf_-_1030_-_Expose.pdf","Title":"960-71130_-_Wohnung_-_Kauf_-_1030_-_Expose","Description":"","Sort_order":null,"Uploaded_at":"2025-03-12T14:36:30+01:00","Visibility":1,"Active":true,"Group":null,"Original_filesize":9993954,"Mime_type":"application/pdf","Width":0,"Height":0,"Thumbnails":null,"AdditionalProperties":{}},{"Type":1,"Storage_key":"2ZSazQaCQ6lS3HejGtfdjk.pdf","Url":"https://storage.justimmo.at/file/2ZSazQaCQ6lS3HejGtfdjk.pdf","Original_filename":"2024_04_Maklervertrag und AGB.pdf","Title":"","Description":"","Sort_order":null,"Uploaded_at":"2025-02-17T09:26:51+01:00","Visibility":0,"Active":true,"Group":null,"Original_filesize":106852,"Mime_type":"application/pdf","Width":0,"Height":0,"Thumbnails":null,"AdditionalProperties":{}}],"From":"0001-01-01 00:00:00Z","To":"0001-01-01 00:00:00Z"}',
    285177903:
      '{"ActivityTypeId":34,"ActivityTypeName":"Objekt\\u00FCbergabe","Comment":"Der Termin f\\u00FCr die Schl\\u00FCssel\\u00FCbergabe findet an 01.04.2025 um 13:00 Uhr in der Wohnung statt.","Created_at":"2025-03-17T10:29:22+01:00","Offertext":null,"Files":[],"From":"2025-04-01 11:00:00Z","To":"0001-01-01 00:00:00Z"}',
    285178275:
      '{"ActivityTypeId":61,"ActivityTypeName":"Beh\\u00F6rdenweg","Comment":"Ich habe beim zust\\u00E4ndigen Amt die Pl\\u00E4ne eingeholt. Ich habe Sie Ihnen ins immo-drive gestellt.\\r\\nFreundliche Gr\\u00FC\\u00DFe Sabine Hofer","Created_at":"2025-03-17T10:30:36+01:00","Offertext":null,"Files":[],"From":"2025-02-09 23:00:00Z","To":"0001-01-01 00:00:00Z"}',
    285178416:
      '{"ActivityTypeId":33,"ActivityTypeName":"Verkaufstafel","Comment":"Ich habe eine Verkaufstafel am Fenster in Ihrer Wohnung befestigt. Freundliche Gr\\u00FC\\u00DFe Sabine Hofer","Created_at":"2025-03-17T10:31:17+01:00","Offertext":null,"Files":[],"From":"2025-02-10 23:00:00Z","To":"0001-01-01 00:00:00Z"}',
    285178794:
      '{"ActivityTypeId":8,"ActivityTypeName":"Besichtigung","Comment":"Bereits die erste Besichtigung verlief sehr vielversprechend. Ich freue mich auf der R\\u00FCckmeldung der Interessentin. Besonders gut gef\\u00E4llt ihr die Lage und der Grundriss der Wohnung. Ich halte Sie weiterhin auf dem Laufenden! Freundliche Gr\\u00FC\\u00DFe Sabine Hofer","Created_at":"2025-03-17T10:33:18+01:00","Offertext":null,"Files":[],"From":"2025-02-12 09:00:00Z","To":"0001-01-01 00:00:00Z"}',
    285179715:
      '{"ActivityTypeId":8,"ActivityTypeName":"Besichtigung","Comment":"Heute war ich nun wieder f\\u00FCr eine Besichtigung vor Ort. Es lief ganz gut und die Wohnung hat einen positiven Eindruck hinterlassen.","Created_at":"2025-03-17T10:37:36+01:00","Offertext":null,"Files":[],"From":"2025-02-27 14:00:00Z","To":"0001-01-01 00:00:00Z"}',
    285179931:
      '{"ActivityTypeId":6,"ActivityTypeName":"Aushang","Comment":"Es h\\u00E4ngen nun Immobilienangebote zu Ihrer Immobilie in allen Erste Bank Filialen des 2. und 3. Bezirk. Freundliche Gr\\u00FC\\u00DFe Sabine Hofer","Created_at":"2025-03-17T10:38:28+01:00","Offertext":null,"Files":[],"From":"2025-02-28 11:00:00Z","To":"0001-01-01 00:00:00Z"}',
    285180150:
      '{"ActivityTypeId":8,"ActivityTypeName":"Besichtigung","Comment":"Besichtigung lief gut und es gibt eine Kaufabsicht. Ich habe den Kunden nun auf Wunsch an unsere Finanzierer von der Erste Bank weitergeleitet. Die sind immer sehr schnell. Ich halte Sie auf dem Laufenden! Freundliche Gr\\u00FC\\u00DFe Sabine Hofer","Created_at":"2025-03-17T10:39:41+01:00","Offertext":null,"Files":[],"From":"2025-03-02 23:00:00Z","To":"0001-01-01 00:00:00Z"}',
    285180825:
      '{"ActivityTypeId":8,"ActivityTypeName":"Besichtigung","Comment":"Es war die zweite Besichtigung mit der Kundin. Diesmal hat sie einen Sachverst\\u00E4ndigen mitgebracht, f\\u00FCr die Begutachtung des Kellers bzgl. Feuchtigkeit. Alles top - sagte der. Die Finanzierung konnte Sie bereits mit unserem Finanzierer der Erste Bank abkl\\u00E4ren. Hier funktioniert auch alles. Es l\\u00E4uft also nach Plan! Die Kundin bat mich, ich ein Kaufanbotsdokument zu \\u00FCbermitteln. Ich hoffe ich kann mich bald mit positiven Neuigkeiten bei Ihnen melden. Daumen dr\\u00FCcken! Freundliche Gr\\u00FC\\u00DFe Sabine Hofer","Created_at":"2025-03-17T10:42:24+01:00","Offertext":null,"Files":[],"From":"2025-03-12 10:30:00Z","To":"0001-01-01 00:00:00Z"}',
    285181437:
      '{"ActivityTypeId":10,"ActivityTypeName":"Inserat","Comment":"Ein Inserat Ihrer Immobilie ist nun für die kommende Ausgabe des sREAL WOHNEN Magazins eingeplant. Sie erhalten es bei uns direkt (B\\u00FCro der s Real am Rochusmarkt oder auch alle anderen Standorte in \\u00D6sterreich), in Ihrer Erste Bank Filiale oder sie bl\\u00E4ttern es online durch. Freundliche Gr\\u00FC\\u00DFe Sabine Hofer","Created_at":"2025-03-17T10:45:46+01:00","Offertext":null,"Files":[],"From":"2025-02-13 09:00:00Z","To":"0001-01-01 00:00:00Z"}',
    285181632:
      '{"ActivityTypeId":10,"ActivityTypeName":"Inserat","Comment":"Ich habe Ihre Immobilie nun wie besprochen im \\u0022Immofokus\\u0022 inseriert. Freundliche Gr\\u00FC\\u00DFe Sabine Hofer","Created_at":"2025-03-17T10:46:48+01:00","Offertext":null,"Files":[],"From":"2025-02-17 07:00:00Z","To":"0001-01-01 00:00:00Z"}',
    285181857:
      '{"ActivityTypeId":8,"ActivityTypeName":"Besichtigung","Comment":"Heute Abend fand eine sehr vielversprechende Besichtigung statt. Ich melde mich, sobald es Neuigkeiten gibt. Freundliche Gr\\u00FC\\u00DFe Sabine Hofer","Created_at":"2025-03-17T10:47:52+01:00","Offertext":null,"Files":[],"From":"2025-02-25 16:00:00Z","To":"0001-01-01 00:00:00Z"}',
    285186288:
      '{"ActivityTypeId":8,"ActivityTypeName":"Besichtigung","Comment":"Heute hat ebenfalls wieder eine sehr nette Besichtigung stattgefunden. Die Familie besichtig die Woche noch 3andere Immobilien und meldet sich dann bei mir. Ich halte Sie auf dem Laufenden. Freundliche Gr\\u00FC\\u00DFe Sabine Hofer","Created_at":"2025-03-17T11:05:29+01:00","Offertext":null,"Files":[],"From":"2025-02-13 23:00:00Z","To":"0001-01-01 00:00:00Z"}',
    285186594:
      '{"ActivityTypeId":1196,"ActivityTypeName":"Online-Besichtigung","Comment":"Heute hat eine Online-Besichtigung stattgefunden, da der potentielle Kunde aktuell noch im Ausland lebt und plant in den n\\u00E4chsten Monaten mit seiner Familie aus beruflichen Gr\\u00FCnden nach Wien zu ziehen.","Created_at":"2025-03-17T11:07:09+01:00","Offertext":null,"Files":[],"From":"2025-02-18 23:00:00Z","To":"0001-01-01 00:00:00Z"}',
    room_layout: null,
    preview_plan: {
      storage_key: [],
      sizes: [[[]], [[]], [[]]],
    },
    year_of_last_comprehensive_renovation: null,
    realty_condition: {
      id: [],
      name: [],
    },
    building_condition: null,
    vendor_economic_relationship: 'none',
    dual_brokerage: false,
    automatic_hits: true,
    land_register_entries: [],
    ownership_type: null,
    furnishing: null,
    noise_level: null,
    location_assessment: null,
    floors: {
      count_floors: [],
      count_attic_floors: [],
      mezzanine: [],
    },
    ImmoLiveHighestBid: 0,
  },
};

export const abgeberimmo_phase2_parsed = parseImmo(abgeberimmo_phase2);

export const abgeberimmo_phase2_categories = {
  groups: [
    {
      id: 'traffic',
      name: 'Verkehr',
      categories: [
        {
          id: 'bus',
          name: 'Bus',
          distance: 66,
          additionalProperties: {},
        },
        {
          id: 'subway',
          name: 'U-Bahn',
          distance: 239,
          additionalProperties: {},
        },
        {
          id: 'tram',
          name: 'Straßenbahn',
          distance: 564,
          additionalProperties: {},
        },
        {
          id: 'railway_station',
          name: 'Bahnhof',
          distance: 278,
          additionalProperties: {},
        },
        {
          id: 'motorway_junction',
          name: 'Autobahnanschluss',
          distance: 1293,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      id: 'local_supply',
      name: 'Nahversorgung',
      categories: [
        {
          id: 'supermarket',
          name: 'Supermarkt',
          distance: 28,
          additionalProperties: {},
        },
        {
          id: 'bakery',
          name: 'Bäckerei',
          distance: 151,
          additionalProperties: {},
        },
        {
          id: 'mall',
          name: 'Einkaufszentrum',
          distance: 204,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      id: 'health',
      name: 'Gesundheit',
      categories: [
        {
          id: 'doctors',
          name: 'Arzt',
          distance: 210,
          additionalProperties: {},
        },
        {
          id: 'pharmacy',
          name: 'Apotheke',
          distance: 216,
          additionalProperties: {},
        },
        {
          id: 'clinic',
          name: 'Klinik',
          distance: 346,
          additionalProperties: {},
        },
        {
          id: 'hospital',
          name: 'Krankenhaus',
          distance: 294,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      id: 'children_and_school',
      name: 'Kinder & Schulen',
      categories: [
        {
          id: 'school',
          name: 'Schule',
          distance: 225,
          additionalProperties: {},
        },
        {
          id: 'kindergarten',
          name: 'Kindergarten',
          distance: 263,
          additionalProperties: {},
        },
        {
          id: 'university',
          name: 'Universität',
          distance: 896,
          additionalProperties: {},
        },
        {
          id: 'college',
          name: 'Höhere Schule',
          distance: 317,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      id: 'other',
      name: 'Sonstige',
      categories: [
        {
          id: 'atm',
          name: 'Geldautomat',
          distance: 19,
          additionalProperties: {},
        },
        {
          id: 'bank',
          name: 'Bank',
          distance: 19,
          additionalProperties: {},
        },
        {
          id: 'post_office',
          name: 'Post',
          distance: 378,
          additionalProperties: {},
        },
        {
          id: 'police',
          name: 'Polizei',
          distance: 169,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
  ],
  additionalProperties: {},
};

export const abgeberimmo_phase3 = {
  id: 14513184,
  tenant_id: 960,
  created_at: '2025-03-04T10:35:18+01:00',
  updated_at: '2025-03-20T13:01:20+01:00',
  published_at: '2025-03-20T12:59:56+01:00',
  catalogue_number: {
    plain: 71129,
    display: '960/71129',
    additionalProperties: {},
  },
  status: {
    id: 5,
    name: 'aktiv',
    until: null,
    additionalProperties: {},
  },
  address: {
    street: null,
    number: null,
    entrance: null,
    door: null,
    zip: null,
    city: null,
    floor: null,
    country: null,
    geo_coordinates: null,
  },
  public_address: {
    street: null,
    number: null,
    entrance: null,
    door: null,
    zip: '1030',
    city: 'Wien',
    country: 'AT',
    geo_coordinates: {
      latitude: 48.2017333,
      longitude: 16.3916496,
      additionalProperties: {},
    },
    fuzzy_geo_coordinates: {
      latitude: 48.1980826,
      longitude: 16.39832571,
      radius: 255,
      additionalProperties: {},
    },
  },
  land_registry_number: null,
  cadastral_municipality: null,
  plot_number: null,
  system_type: 0,
  parent_id: null,
  type: {
    id: 2,
    name: 'Wohnung',
    openimmo_key: 'wohnung',
    additionalProperties: {},
  },
  subtype: null,
  occupancy: {
    residential: true,
    commercial: false,
    investment: false,
    additionalProperties: {},
  },
  marketing_type: 0,
  architecture: 0,
  'year_of_export construction': null,
  infrastructure_provision: null,
  year_of_last_renovation: null,
  areas: {
    site_area: null,
    living_area: {
      area: 68,
    },
    floor_area: null,
    developable_area: null,
    office_area: null,
    sales_area: null,
    storage_area: null,
    available_area: null,
    short_term_area: null,
    total_area: null,
    weighted_area: null,
    undeveloped_attic_area: null,
    garden_area: null,
    basement_area: null,
    balcony_area: null,
    terrace_area: null,
    covered_balcony_area: null,
    garage_area: null,
    parking_space_area: null,
  },
  rooms: {
    rooms: 2,
    toilets: null,
    bathrooms: null,
    storerooms: null,
  },
  prices: {
    publish_prices: true,
    purchase_price: {
      currency: 'EUR',
      net: 480000,
      gross: 480000,
      vat_absolute: 0,
      vat_percentage: 0,
    },
    rent: null,
    furniture_hire: {
      currency: 'EUR',
      net: 0,
      gross: 0,
      vat_absolute: 0,
      vat_percentage: 0,
    },
    parking: {
      currency: 'EUR',
      net: 0,
      gross: 0,
      vat_absolute: 0,
      vat_percentage: 0,
    },
    garage: {
      currency: 'EUR',
      net: 0,
      gross: 0,
      vat_absolute: 0,
      vat_percentage: 0,
    },
    operating: {
      currency: 'EUR',
      net: 0,
      gross: 0,
      vat_absolute: 0,
      vat_percentage: 0,
    },
    heating: {
      currency: 'EUR',
      net: 0,
      gross: 0,
      vat_absolute: 0,
      vat_percentage: 0,
    },
    hot_water: {
      currency: 'EUR',
      net: 0,
      gross: 0,
      vat_absolute: 0,
      vat_percentage: 0,
    },
    cooling: {
      currency: 'EUR',
      net: 0,
      gross: 0,
      vat_absolute: 0,
      vat_percentage: 0,
    },
    maintenance_funds: {
      currency: 'EUR',
      net: 0,
      gross: 0,
      vat_absolute: 0,
      vat_percentage: 0,
    },
    elevator: {
      currency: 'EUR',
      net: 0,
      gross: 0,
      vat_absolute: 0,
      vat_percentage: 0,
    },
    others: {
      currency: 'EUR',
      net: 0,
      gross: 0,
      vat_absolute: 0,
      vat_percentage: 0,
    },
  },
  earnings_per_year: {
    currency: 'EUR',
    net: 0,
    additionalProperties: {},
  },
  obtainable_from: {
    date: '0001-01-01T00:00:00+00:00',
    text: '',
  },
  preview_image: {
    storage_key: '1zBVcOf8f9NZ9CV15zrSh2.jpeg',
    sizes: {
      original: [],
      fm_small: [],
      medium: [],
    },
  },
  categories: [],
  custom_fields: [
    {
      type: 0,
      name: 'custom_1',
      value:
        '\u003Ch1\u003E3., Wohnen im Herzen von Wien\u003C/h1\u003E\r\n\r\n\u003Cp\u003EWfl. 68 m\u00B2, 2 Zimmer, Badezimmer mit WC, zentral begehbar, Wohnk\u00FCche, sehr moderne Ausstattung, sensationelle Infrastruktur in der N\u00E4he von Wien Mitte.\u003C/p\u003E',
      locale: 'de',
    },
  ],
  agent: {
    id: 19442197,
    prefix: '',
    first_name: dummymakler4.firstName,
    last_name: dummymakler4.lastName,
    gender: 0,
    suffix: 'BA',
    email: `${dummymakler4.firstName.toLowerCase()}.${dummymakler4.lastName.toLowerCase()}@sreal.at`,
    phone: '\u002B43 664 8388745',
    phone_business: '\u002B43 (0)5 0100 - 26261',
    phone_mobile: '\u002B43 664 8388745',
    profile_picture: {
      storage_key: dummymakler4.profilePictureFileId,
      filename: 'dummymakler4.png',
      title: null,
    },
    immobiliencard_id: '',
    immobiliencard_uid: null,
    foreign_id: 35471,
    role: 0,
    permissions: null,
    tenant: {
      id: 960,
      name: 's REAL Immobilienvermittlung GmbH',
      email: 'kundenbetreuung@sreal.at',
      phone: '',
      address: {
        street: 'Landstra\u00DFer Hauptstra\u00DFe 60',
        zip: '1030',
        city: 'Wien',
        country: 'AT',
      },
    },
  },
  active_for_export: true,
  accessible: false,
  contacts: [
    {
      role: 1,
      prospect_state: 0,
      contact: {
        id: 38078478,
        created_at: '2025-03-04T10:50:15+01:00',
        updated_at: '2025-03-17T09:42:32+01:00',
        additionalProperties: {},
      },
    },
  ],
  files: [
    {
      type: 0,
      storage_key: '1zBVcOf8f9NZ9CV15zrSh2.jpeg',
      url: 'https://storage.justimmo.at/file/1zBVcOf8f9NZ9CV15zrSh2.jpeg',
      original_filename: 'Wohnk\u00FCche.jpeg',
      title: '',
      description: '',
      sort_order: 0,
      uploaded_at: '2025-03-17T12:38:49+01:00',
      visibility: 0,
      active: true,
      group: {
        id: 1,
      },
      original_filesize: 541634,
      mime_type: 'image/jpeg',
      width: 1792,
      height: 1024,
      thumbnails: [
        {
          name: 'small',
          url: 'https://storage.justimmo.at/thumb/c99f4f7cd48a220afdf7974d0157bdf1/fc_h300_w100/1zBVcOf8f9NZ9CV15zrSh2.jpeg',
        },
        {
          name: 'fullhd',
          url: 'https://storage.justimmo.at/thumb/da7aa1b268be37b1f7898bd2bd6b1671/fc_h1080_w1920/1zBVcOf8f9NZ9CV15zrSh2.jpeg',
        },
        {
          name: 'fullhd_branded',
          url: 'https://storage.justimmo.at/thumb/7bac56b624329a4211b7adf2177d000b/Fc_Ltl_Ms58xncItneAknwZKGdek0.png_fc_h1080_w1920/1zBVcOf8f9NZ9CV15zrSh2.jpeg',
        },
      ],
      additionalProperties: {},
    },
    {
      type: 0,
      storage_key: '3rFBduWY9gUqiwHoq4lbbV.jpeg',
      url: 'https://storage.justimmo.at/file/3rFBduWY9gUqiwHoq4lbbV.jpeg',
      original_filename: 'Vorzimmer.jpeg',
      title: '',
      description: '',
      sort_order: 3,
      uploaded_at: '2025-03-17T12:38:48+01:00',
      visibility: 0,
      active: true,
      group: {
        id: 1,
      },
      original_filesize: 219046,
      mime_type: 'image/jpeg',
      width: 1432,
      height: 785,
      thumbnails: [
        {
          name: 'small',
          url: 'https://storage.justimmo.at/thumb/f44f45073b5ac113a2ab1f61fbf0d083/fc_h300_w100/3rFBduWY9gUqiwHoq4lbbV.jpeg',
        },
        {
          name: 'fullhd',
          url: 'https://storage.justimmo.at/thumb/b13aac9cebca4bea2c74ec98ca6f60c9/fc_h1080_w1920/3rFBduWY9gUqiwHoq4lbbV.jpeg',
        },
        {
          name: 'fullhd_branded',
          url: 'https://storage.justimmo.at/thumb/a2714deee4dab8f5a34b92548681192a/Fc_Ltl_Ms58xncItneAknwZKGdek0.png_fc_h1080_w1920/3rFBduWY9gUqiwHoq4lbbV.jpeg',
        },
      ],
      additionalProperties: {},
    },
    {
      type: 0,
      storage_key: '1U72QPEag35juWBAaBSlAy.jpeg',
      url: 'https://storage.justimmo.at/file/1U72QPEag35juWBAaBSlAy.jpeg',
      original_filename: 'Schlafzimmer.jpeg',
      title: '',
      description: '',
      sort_order: 1,
      uploaded_at: '2025-03-17T12:38:47+01:00',
      visibility: 0,
      active: true,
      group: {
        id: 1,
      },
      original_filesize: 377807,
      mime_type: 'image/jpeg',
      width: 1792,
      height: 1024,
      thumbnails: [
        {
          name: 'small',
          url: 'https://storage.justimmo.at/thumb/44a7fbc7160f6baabc51e2a66c8311f0/fc_h300_w100/1U72QPEag35juWBAaBSlAy.jpeg',
        },
        {
          name: 'fullhd',
          url: 'https://storage.justimmo.at/thumb/4e6109b6623ea8263a5cca443fb74197/fc_h1080_w1920/1U72QPEag35juWBAaBSlAy.jpeg',
        },
        {
          name: 'fullhd_branded',
          url: 'https://storage.justimmo.at/thumb/992a85d1297df67916ccfbb11e99d6d6/Fc_Ltl_Ms58xncItneAknwZKGdek0.png_fc_h1080_w1920/1U72QPEag35juWBAaBSlAy.jpeg',
        },
      ],
      additionalProperties: {},
    },
    {
      type: 0,
      storage_key: '1yA5lyVu4tvtYPp8vv0IjW.jpeg',
      url: 'https://storage.justimmo.at/file/1yA5lyVu4tvtYPp8vv0IjW.jpeg',
      original_filename: 'Badezimmer.jpeg',
      title: '',
      description: '',
      sort_order: 2,
      uploaded_at: '2025-03-17T12:38:47+01:00',
      visibility: 0,
      active: true,
      group: {
        id: 1,
      },
      original_filesize: 468872,
      mime_type: 'image/jpeg',
      width: 1792,
      height: 1024,
      thumbnails: [
        {
          name: 'small',
          url: 'https://storage.justimmo.at/thumb/1563d768007825bd952d0cbe86af8810/fc_h300_w100/1yA5lyVu4tvtYPp8vv0IjW.jpeg',
        },
        {
          name: 'fullhd',
          url: 'https://storage.justimmo.at/thumb/554b5602a7f607873eac2a7509f42ac7/fc_h1080_w1920/1yA5lyVu4tvtYPp8vv0IjW.jpeg',
        },
        {
          name: 'fullhd_branded',
          url: 'https://storage.justimmo.at/thumb/fe83aee11265ba51ab1fb53325d2c158/Fc_Ltl_Ms58xncItneAknwZKGdek0.png_fc_h1080_w1920/1yA5lyVu4tvtYPp8vv0IjW.jpeg',
        },
      ],
      additionalProperties: {},
    },
    {
      type: 0,
      storage_key: 'V70065TMMuncKMCFfBHiN.jpg',
      url: 'https://storage.justimmo.at/file/V70065TMMuncKMCFfBHiN.jpg',
      original_filename: 'Plan.jpg',
      title: '',
      description: '',
      sort_order: 0,
      uploaded_at: '2025-03-15T09:12:08+01:00',
      visibility: 0,
      active: true,
      group: {
        id: 2,
      },
      original_filesize: 266565,
      mime_type: 'image/jpeg',
      width: 2215,
      height: 3045,
      thumbnails: [
        {
          name: 'small',
          url: 'https://storage.justimmo.at/thumb/5e993e35bacd590165dd1be381417d6f/fc_h300_w100/V70065TMMuncKMCFfBHiN.jpg',
        },
        {
          name: 'fullhd',
          url: 'https://storage.justimmo.at/thumb/16996aac4e769b5579b5e297716a2982/fc_h1080_w1920/V70065TMMuncKMCFfBHiN.jpg',
        },
        {
          name: 'fullhd_branded',
          url: 'https://storage.justimmo.at/thumb/927097f9697b78b1a47970f82e3a80ec/Fc_Ltl_Ms58xncItneAknwZKGdek0.png_fc_h1080_w1920/V70065TMMuncKMCFfBHiN.jpg',
        },
      ],
      additionalProperties: {},
    },
    {
      type: 0,
      storage_key: '3dNiKBVWrudeDSxuqNPE57.png',
      url: 'https://storage.justimmo.at/file/3dNiKBVWrudeDSxuqNPE57.png',
      original_filename: 'Lageplan.png',
      title: '',
      description: '',
      sort_order: 1,
      uploaded_at: '2025-03-04T10:32:01+01:00',
      visibility: 0,
      active: true,
      group: {
        id: 2,
      },
      original_filesize: 571116,
      mime_type: 'image/png',
      width: 2048,
      height: 1360,
      thumbnails: [
        {
          name: 'small',
          url: 'https://storage.justimmo.at/thumb/eb2640f9d36e5478da4495921e834636/fc_h300_w100/3dNiKBVWrudeDSxuqNPE57.png',
        },
        {
          name: 'fullhd',
          url: 'https://storage.justimmo.at/thumb/fa85dc78fcca559e5aa7b29e84031e8d/fc_h1080_w1920/3dNiKBVWrudeDSxuqNPE57.png',
        },
        {
          name: 'fullhd_branded',
          url: 'https://storage.justimmo.at/thumb/c91b34ed14500e4c001dcf55534d67a8/Fc_Ltl_Ms58xncItneAknwZKGdek0.png_fc_h1080_w1920/3dNiKBVWrudeDSxuqNPE57.png',
        },
      ],
      additionalProperties: {},
    },
  ],
  internal_files: [],
  texts: {
    label: '',
    title: [
      {
        value: 'Moderne 2-Zimmer Wohnung in ausgezeichneter Lage',
        locale: 'de',
        additionalProperties: {},
      },
    ],
    location: [
      {
        value:
          'Diese attraktive Wohnung in 1030 Wien besticht durch ihre zentrale Lage und hervorragende Infrastruktur. In unmittelbarer N\u00E4he finden Sie alles, was das Herz begehrt: \u00C4rzte, Apotheken, Kliniken und Schulen sind bequem erreichbar. Superm\u00E4rkte, B\u00E4ckereien und ein Einkaufszentrum sorgen f\u00FCr Ihre t\u00E4glichen Besorgungen. Auch \u00F6ffentliche Verkehrsmittel wie Bus, U-Bahn und Stra\u00DFenbahn bieten eine optimale Anbindung. Hier wohnen Sie mitten im pulsierenden Leben Wiens!',
        locale: 'de',
        additionalProperties: {},
      },
    ],
    description: [
      {
        value:
          '\u003Cp\u003EHerzlich willkommen in Ihrem neuen Zuhause im Herzen des 3. Bezirks von Wien! Diese charmante Wohnung besticht nicht nur durch ihre hervorragende Lage, sondern auch durch zahlreiche Annehmlichkeiten, die das Stadtleben besonders angenehm gestalten.\u003C/p\u003E\r\n\r\n\u003Cp\u003EMit einer Wohnfl\u00E4che von 68 m\u00B2 und zwei gut geschnittenen Zimmern bietet diese Immobilie den perfekten R\u00FCckzugsort f\u00FCr Paare oder alle, die Wert auf Raum und Komfort legen.\u003C/p\u003E\r\n\r\n\u003Cp\u003EDie Wohnung ist mit hochwertigen Materialien ausgestattet, darunter elegantes Parkett und eine moderne Fu\u00DFbodenheizung, die f\u00FCr ein behagliches Wohngef\u00FChl sorgt. Die offene Einbauk\u00FCche ist nicht nur praktisch, sondern auch ein stilvoller Mittelpunkt, der das Kochen zu einem wahren Vergn\u00FCgen macht. Egal, ob Sie ein schnelles Fr\u00FChst\u00FCck oder ein ausgedehntes Abendessen f\u00FCr Freunde zubereiten \u2013 hier wird jeder Moment zu einem besonderen Erlebnis.\u003C/p\u003E\r\n\r\n\u003Cp\u003EEin weiterer Vorteil dieser Immobilie ist die ausgezeichnete Verkehrsanbindung. Mit Bus, U-Bahn, Stra\u00DFenbahn und dem Bahnhof in unmittelbarer N\u00E4he sind Sie bestens vernetzt und erreichen schnell Ihr Ziel \u2013 sei es zur Arbeit, zum Einkaufen oder zu Freizeitaktivit\u00E4ten.\u003C/p\u003E\r\n\r\n\u003Cp\u003EDie Umgebung bietet alles, was Sie f\u00FCr den t\u00E4glichen Bedarf ben\u00F6tigen. \u00C4rzte, Apotheken, Kliniken und Krankenh\u00E4user sind ebenso in der N\u00E4he wie Schulen, Kinderg\u00E4rten und Universit\u00E4ten. Superm\u00E4rkte, B\u00E4ckereien und ein Einkaufszentrum befinden sich ebenfalls in der Umgebung, sodass Sie alles, was Sie brauchen, in k\u00FCrzester Zeit erreichen k\u00F6nnen.\u003C/p\u003E\r\n\r\n\u003Cp\u003EVerpassen Sie nicht diese einmalige Gelegenheit! Diese Wohnung ist mehr als nur ein Ort zum Wohnen \u2013 sie ist ein Lebensraum, der Ihnen Komfort, Stil und eine hervorragende Lebensqualit\u00E4t bietet. Kontaktieren Sie uns noch heute, um einen Besichtigungstermin zu vereinbaren und sich selbst von diesem wunderbaren Angebot in 1030 Wien zu \u00FCberzeugen!\u003C/p\u003E',
        locale: 'de',
        additionalProperties: {},
      },
    ],
    description_expose: [
      {
        value:
          '\u003Cp\u003EHerzlich willkommen in Ihrem neuen Zuhause im Herzen des 3. Bezirks von Wien! Diese charmante Wohnung besticht nicht nur durch ihre hervorragende Lage, sondern auch durch zahlreiche Annehmlichkeiten, die das Stadtleben besonders angenehm gestalten.\u003C/p\u003E\r\n\r\n\u003Cp\u003EMit einer Wohnfl\u00E4che von 68 m\u00B2 und zwei gut geschnittenen Zimmern bietet diese Immobilie den perfekten R\u00FCckzugsort f\u00FCr Paare oder alle, die Wert auf Raum und Komfort legen.\u003C/p\u003E\r\n\r\n\u003Cp\u003EDie Wohnung ist mit hochwertigen Materialien ausgestattet, darunter elegantes Parkett und eine moderne Fu\u00DFbodenheizung, die f\u00FCr ein behagliches Wohngef\u00FChl sorgt. Die offene Einbauk\u00FCche ist nicht nur praktisch, sondern auch ein stilvoller Mittelpunkt, der das Kochen zu einem wahren Vergn\u00FCgen macht. Egal, ob Sie ein schnelles Fr\u00FChst\u00FCck oder ein ausgedehntes Abendessen f\u00FCr Freunde zubereiten \u2013 hier wird jeder Moment zu einem besonderen Erlebnis.\u003C/p\u003E\r\n\r\n\u003Cp\u003EEin weiterer Vorteil dieser Immobilie ist die ausgezeichnete Verkehrsanbindung. Mit Bus, U-Bahn, Stra\u00DFenbahn und dem Bahnhof in unmittelbarer N\u00E4he sind Sie bestens vernetzt und erreichen schnell Ihr Ziel \u2013 sei es zur Arbeit, zum Einkaufen oder zu Freizeitaktivit\u00E4ten.\u003C/p\u003E\r\n\r\n\u003Cp\u003EDie Umgebung bietet alles, was Sie f\u00FCr den t\u00E4glichen Bedarf ben\u00F6tigen. \u00C4rzte, Apotheken, Kliniken und Krankenh\u00E4user sind ebenso in der N\u00E4he wie Schulen, Kinderg\u00E4rten und Universit\u00E4ten. Superm\u00E4rkte, B\u00E4ckereien und ein Einkaufszentrum befinden sich ebenfalls in der Umgebung, sodass Sie alles, was Sie brauchen, in k\u00FCrzester Zeit erreichen k\u00F6nnen.\u003C/p\u003E\r\n\r\n\u003Cp\u003EVerpassen Sie nicht diese einmalige Gelegenheit! Diese Wohnung ist mehr als nur ein Ort zum Wohnen \u2013 sie ist ein Lebensraum, der Ihnen Komfort, Stil und eine hervorragende Lebensqualit\u00E4t bietet. Kontaktieren Sie uns noch heute, um einen Besichtigungstermin zu vereinbaren und sich selbst von diesem wunderbaren Angebot in 1030 Wien zu \u00FCberzeugen!\u003C/p\u003E',
        locale: 'de',
        additionalProperties: {},
      },
    ],
    additionalProperties: {},
  },
  energy_performance_certification: {
    energy_performance: {
      value: 1.83,
      class: 1,
      additionalProperties: {},
    },
    heating_demand: {
      value: 33.3,
      class: 2,
      additionalProperties: {},
    },
    valid_until: '2028-01-13T00:00:00+00:00',
    auto_disclaimer: false,
    additionalProperties: {},
  },
  features: [
    {
      group_label: 'Boden',
      items: [
        {
          id: 7,
          label: 'Parkett',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      group_label: 'Heizungsart',
      items: [
        {
          id: 18,
          label: 'Fu\u00DFbodenheizung',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      group_label: 'K\u00FCche',
      items: [
        {
          id: 22,
          label: 'Einbauk\u00FCche',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      group_label: 'Fahrstuhl',
      items: [
        {
          id: 25,
          label: 'Personenaufzug',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      group_label: 'Bad',
      items: [
        {
          id: 35,
          label: 'Dusche',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      group_label: 'Stellplatzart',
      items: [
        {
          id: 46,
          label: 'Parkplatz',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      group_label: 'Fenster',
      items: [
        {
          id: 154,
          label: 'Au\u00DFenliegender Sonnenschutz',
          tenant_id: null,
          additionalProperties: {},
        },
        {
          id: 157,
          label: '\u00D6ffenbare Fenster',
          tenant_id: null,
          additionalProperties: {},
        },
        {
          id: 670,
          label: 'Doppel- / Mehrfachverglasung',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      group_label: 'Ausblick',
      items: [
        {
          id: 664,
          label: 'Stadtblick',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      group_label: 'Bauweise',
      items: [
        {
          id: 945,
          label: 'Ziegel',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
  ],
  links: [],
  residential_aggregation_data: null,
  commission: {
    prospect: {
      text_value: '3% des Kaufpreises zzgl. 20% USt.',
    },
  },
  condition_assessment: null,
  is_public: true,
  agency_agreement: {
    valid_from: null,
    valid_until: null,
    agency_agreement_type: 0,
    agreement_method: null,
    additionalProperties: {
      business_opportunity_knowledge_date: null,
    },
  },
  additionalProperties: {
    room_layout: null,
    preview_plan: {
      storage_key: [],
      sizes: [[[]], [[]], [[]]],
    },
    year_of_last_comprehensive_renovation: null,
    realty_condition: {
      id: [],
      name: [],
    },
    building_condition: null,
    vendor_economic_relationship: 'none',
    dual_brokerage: false,
    automatic_hits: true,
    land_register_entries: [],
    ownership_type: null,
    furnishing: null,
    noise_level: null,
    location_assessment: null,
    floors: {
      count_floors: [],
      count_attic_floors: [],
      mezzanine: [],
    },
  },
};

export const abgeberimmo_phase3_parsed = parseImmo(abgeberimmo_phase3);

export const abgeberimmo_phase3_categories = {
  groups: [
    {
      id: 'traffic',
      name: 'Verkehr',
      categories: [
        {
          id: 'bus',
          name: 'Bus',
          distance: 66,
          additionalProperties: {},
        },
        {
          id: 'subway',
          name: 'U-Bahn',
          distance: 239,
          additionalProperties: {},
        },
        {
          id: 'tram',
          name: 'Straßenbahn',
          distance: 564,
          additionalProperties: {},
        },
        {
          id: 'railway_station',
          name: 'Bahnhof',
          distance: 278,
          additionalProperties: {},
        },
        {
          id: 'motorway_junction',
          name: 'Autobahnanschluss',
          distance: 1293,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      id: 'local_supply',
      name: 'Nahversorgung',
      categories: [
        {
          id: 'supermarket',
          name: 'Supermarkt',
          distance: 28,
          additionalProperties: {},
        },
        {
          id: 'bakery',
          name: 'Bäckerei',
          distance: 151,
          additionalProperties: {},
        },
        {
          id: 'mall',
          name: 'Einkaufszentrum',
          distance: 204,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      id: 'health',
      name: 'Gesundheit',
      categories: [
        {
          id: 'doctors',
          name: 'Arzt',
          distance: 210,
          additionalProperties: {},
        },
        {
          id: 'pharmacy',
          name: 'Apotheke',
          distance: 216,
          additionalProperties: {},
        },
        {
          id: 'clinic',
          name: 'Klinik',
          distance: 346,
          additionalProperties: {},
        },
        {
          id: 'hospital',
          name: 'Krankenhaus',
          distance: 294,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      id: 'children_and_school',
      name: 'Kinder & Schulen',
      categories: [
        {
          id: 'school',
          name: 'Schule',
          distance: 225,
          additionalProperties: {},
        },
        {
          id: 'kindergarten',
          name: 'Kindergarten',
          distance: 263,
          additionalProperties: {},
        },
        {
          id: 'university',
          name: 'Universität',
          distance: 896,
          additionalProperties: {},
        },
        {
          id: 'college',
          name: 'Höhere Schule',
          distance: 317,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      id: 'other',
      name: 'Sonstige',
      categories: [
        {
          id: 'atm',
          name: 'Geldautomat',
          distance: 19,
          additionalProperties: {},
        },
        {
          id: 'bank',
          name: 'Bank',
          distance: 19,
          additionalProperties: {},
        },
        {
          id: 'post_office',
          name: 'Post',
          distance: 378,
          additionalProperties: {},
        },
        {
          id: 'police',
          name: 'Polizei',
          distance: 169,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
  ],
  additionalProperties: {},
};

export const abgeberimmo_phase4 = {
  id: 14513232,
  tenant_id: 960,
  created_at: '2025-03-04T10:52:12+01:00',
  updated_at: '2025-03-24T19:36:41+01:00',
  published_at: '2025-03-12T14:26:49+01:00',
  catalogue_number: {
    plain: 71130,
    display: '960/71130',
    additionalProperties: {},
  },
  status: {
    id: 5,
    name: 'aktiv',
    until: null,
    additionalProperties: {},
  },
  address: {
    street: 'Landstraßer Hauptstraße',
    number: '960',
    entrance: null,
    door: '4',
    zip: '1030',
    city: 'Wien',
    floor: null,
    country: 'AT',
    geo_coordinates: {
      latitude: 48.1973583,
      longitude: 16.3954948,
      additionalProperties: {},
    },
  },
  public_address: {
    street: null,
    number: null,
    entrance: null,
    door: null,
    zip: '1030',
    city: 'Wien',
    country: 'AT',
    geo_coordinates: {
      latitude: 48.2017333,
      longitude: 16.3916496,
      additionalProperties: {},
    },
    fuzzy_geo_coordinates: {
      latitude: 48.1980826,
      longitude: 16.39832571,
      radius: 255,
      additionalProperties: {},
    },
  },
  land_registry_number: null,
  cadastral_municipality: null,
  plot_number: null,
  system_type: 0,
  parent_id: null,
  type: {
    id: 2,
    name: 'Wohnung',
    openimmo_key: 'wohnung',
    additionalProperties: {},
  },
  subtype: null,
  occupancy: {
    residential: true,
    commercial: false,
    investment: false,
    additionalProperties: {},
  },
  marketing_type: 0,
  architecture: 0,
  year_of_construction: null,
  infrastructure_provision: null,
  year_of_last_renovation: null,
  areas: {
    site_area: null,
    living_area: {
      area: 148,
    },
    floor_area: null,
    developable_area: null,
    office_area: null,
    sales_area: null,
    storage_area: null,
    available_area: null,
    short_term_area: null,
    total_area: null,
    weighted_area: null,
    undeveloped_attic_area: null,
    garden_area: null,
    basement_area: null,
    balcony_area: {
      area: null,
      count: 2,
    },
    terrace_area: null,
    covered_balcony_area: null,
    garage_area: null,
    parking_space_area: null,
  },
  rooms: {
    rooms: 4,
    toilets: null,
    bathrooms: 2,
    storerooms: null,
  },
  prices: {
    publish_prices: true,
    purchase_price: {
      currency: 'EUR',
      net: 800000,
      gross: 800000,
      vat_absolute: 0,
      vat_percentage: 0,
    },
    rent: null,
    furniture_hire: {
      currency: 'EUR',
      net: 0,
      gross: 0,
      vat_absolute: 0,
      vat_percentage: 0,
    },
    parking: {
      currency: 'EUR',
      net: 0,
      gross: 0,
      vat_absolute: 0,
      vat_percentage: 0,
    },
    garage: {
      currency: 'EUR',
      net: 0,
      gross: 0,
      vat_absolute: 0,
      vat_percentage: 0,
    },
    operating: {
      currency: 'EUR',
      net: 0,
      gross: 0,
      vat_absolute: 0,
      vat_percentage: 0,
    },
    heating: {
      currency: 'EUR',
      net: 0,
      gross: 0,
      vat_absolute: 0,
      vat_percentage: 0,
    },
    hot_water: {
      currency: 'EUR',
      net: 0,
      gross: 0,
      vat_absolute: 0,
      vat_percentage: 0,
    },
    cooling: {
      currency: 'EUR',
      net: 0,
      gross: 0,
      vat_absolute: 0,
      vat_percentage: 0,
    },
    maintenance_funds: {
      currency: 'EUR',
      net: 0,
      gross: 0,
      vat_absolute: 0,
      vat_percentage: 0,
    },
    elevator: {
      currency: 'EUR',
      net: 0,
      gross: 0,
      vat_absolute: 0,
      vat_percentage: 0,
    },
    others: {
      currency: 'EUR',
      net: 0,
      gross: 0,
      vat_absolute: 0,
      vat_percentage: 0,
    },
  },
  earnings_per_year: {
    currency: 'EUR',
    net: 0,
    additionalProperties: {},
  },
  obtainable_from: {
    date: '0001-01-01T00:00:00+00:00',
    text: '',
  },
  preview_image: {
    storage_key: '5oKZIkYbtYErR9fFma1gr4.jpeg',
    sizes: {
      original: [],
      fm_small: [],
      medium: [],
    },
  },
  categories: [],
  custom_fields: [
    {
      type: 0,
      name: 'custom_1',
      value:
        '<h1>3., Luxuriöse 4-Zimmer-Wohnung - Erstbezug</h1>\r\n\r\n<p>Wfl. ca. 148 m², 4 Zimmer, 2 Bäder, Abstellraum,</p>\r\n\r\n<p>Balkon, Keller, Parkplatz, Stadtblick, Klimaanlage,</p>\r\n\r\n<p>Fußbodenheizung, Alarmanlage, Sicherheitskamera,</p>\r\n\r\n<p>Fahrradraum.</p>\r\n\r\n<p> </p>\r\n\r\n<p> </p>',
      locale: 'de',
    },
  ],
  agent: {
    id: 26053533,
    prefix: '',
    first_name: dummymakler4.firstName,
    last_name: dummymakler4.lastName,
    gender: 0,
    suffix: '',
    email: `${dummymakler4.firstName.toLowerCase()}.${dummymakler4.lastName.toLowerCase()}@sreal.at`,
    phone: '+43 664 88304439',
    phone_business: '+43 (0)5 0100 - 26492',
    phone_mobile: '+43 664 88304439',
    profile_picture: {
      storage_key: dummymakler4.profilePictureFileId,
      filename: 'dummymakler4.jpg',
      title: null,
    },
    immobiliencard_id: '',
    immobiliencard_uid: null,
    foreign_id: 38820,
    role: 0,
    permissions: null,
    tenant: {
      id: 960,
      name: 's REAL Immobilienvermittlung GmbH',
      email: 'kundenbetreuung@sreal.at',
      phone: '',
      address: {
        street: 'Landstraßer Hauptstraße 60',
        zip: '1030',
        city: 'Wien',
        country: 'AT',
      },
    },
  },
  active_for_export: true,
  accessible: false,
  contacts: [
    {
      role: 1,
      prospect_state: 0,
      contact: {
        id: 28531171,
        created_at: '2023-07-18T12:56:48+02:00',
        updated_at: '2025-03-24T19:35:54+01:00',
        additionalProperties: {},
      },
    },
    {
      role: 1,
      prospect_state: 0,
      contact: {
        id: 38078622,
        created_at: '2025-03-04T10:58:15+01:00',
        updated_at: '2025-03-17T10:33:50+01:00',
        additionalProperties: {},
      },
    },
  ],
  files: [
    {
      type: 1,
      storage_key: '3YMP06H2NS9932YwBhXmhv.pdf',
      url: 'https://api.justimmo.at/v1/file/3YMP06H2NS9932YwBhXmhv.pdf',
      original_filename: 'Abgeberbrief.pdf',
      title: '',
      description: '',
      sort_order: 99999,
      uploaded_at: '2025-03-17T13:19:33+01:00',
      visibility: 1,
      active: true,
      group: {
        id: 39,
      },
      original_filesize: 4395530,
      mime_type: 'application/pdf',
      width: 0,
      height: 0,
      thumbnails: null,
      additionalProperties: {},
    },
    {
      type: 1,
      storage_key: '7rlQNdVKUIx1yPwsUW3gGz.pdf',
      url: 'https://api.justimmo.at/v1/file/7rlQNdVKUIx1yPwsUW3gGz.pdf',
      original_filename: 'Auslagenexposé.pdf',
      title: '',
      description: '',
      sort_order: 99999,
      uploaded_at: '2025-03-17T13:19:31+01:00',
      visibility: 1,
      active: true,
      group: {
        id: 39,
      },
      original_filesize: 636479,
      mime_type: 'application/pdf',
      width: 0,
      height: 0,
      thumbnails: null,
      additionalProperties: {},
    },
    {
      type: 1,
      storage_key: '7nA160UWLZ4gBr2NzUymGA.pdf',
      url: 'https://api.justimmo.at/v1/file/7nA160UWLZ4gBr2NzUymGA.pdf',
      original_filename: 'Exposé.pdf',
      title: '',
      description: '',
      sort_order: 99999,
      uploaded_at: '2025-03-17T13:19:21+01:00',
      visibility: 1,
      active: true,
      group: {
        id: 40,
      },
      original_filesize: 9668871,
      mime_type: 'application/pdf',
      width: 0,
      height: 0,
      thumbnails: null,
      additionalProperties: {},
    },
    {
      type: 0,
      storage_key: 'GiOpn3NVZGIJdg8IjVfzz.jpeg',
      url: 'https://storage.justimmo.at/file/GiOpn3NVZGIJdg8IjVfzz.jpeg',
      original_filename: 'Kinderzimmer.jpeg',
      title: '',
      description: '',
      sort_order: 3,
      uploaded_at: '2025-03-17T13:13:57+01:00',
      visibility: 0,
      active: true,
      group: {
        id: 1,
      },
      original_filesize: 567922,
      mime_type: 'image/jpeg',
      width: 1792,
      height: 1024,
      thumbnails: [
        {
          name: 'small',
          url: 'https://storage.justimmo.at/thumb/46d0eb3a1afae8d84629b2f4163449e0/fc_h300_w100/GiOpn3NVZGIJdg8IjVfzz.jpeg',
        },
        {
          name: 'fullhd',
          url: 'https://storage.justimmo.at/thumb/dfe48df2ca75467ae8626ef0156f39a7/fc_h1080_w1920/GiOpn3NVZGIJdg8IjVfzz.jpeg',
        },
        {
          name: 'fullhd_branded',
          url: 'https://storage.justimmo.at/thumb/1b3da1729d83577c48937465ff0c727f/Fc_Ltl_Ms58xncItneAknwZKGdek0.png_fc_h1080_w1920/GiOpn3NVZGIJdg8IjVfzz.jpeg',
        },
      ],
      additionalProperties: {},
    },
    {
      type: 0,
      storage_key: '5oKZIkYbtYErR9fFma1gr4.jpeg',
      url: 'https://storage.justimmo.at/file/5oKZIkYbtYErR9fFma1gr4.jpeg',
      original_filename: 'Wohnküche.jpeg',
      title: '',
      description: '',
      sort_order: 0,
      uploaded_at: '2025-03-17T13:13:41+01:00',
      visibility: 0,
      active: true,
      group: {
        id: 1,
      },
      original_filesize: 495097,
      mime_type: 'image/jpeg',
      width: 1792,
      height: 1024,
      thumbnails: [
        {
          name: 'small',
          url: 'https://storage.justimmo.at/thumb/7ab7a55161e6c2bf7b4c64b39c3750ae/fc_h300_w100/5oKZIkYbtYErR9fFma1gr4.jpeg',
        },
        {
          name: 'fullhd',
          url: 'https://storage.justimmo.at/thumb/b3c0deb46123176bd19bba4c96b7b02f/fc_h1080_w1920/5oKZIkYbtYErR9fFma1gr4.jpeg',
        },
        {
          name: 'fullhd_branded',
          url: 'https://storage.justimmo.at/thumb/3d7e9c112c8770220c06f7d30bf5b0d8/Fc_Ltl_Ms58xncItneAknwZKGdek0.png_fc_h1080_w1920/5oKZIkYbtYErR9fFma1gr4.jpeg',
        },
      ],
      additionalProperties: {},
    },
    {
      type: 0,
      storage_key: '7duTPEiZi4ofuEgpSuNPIX.jpeg',
      url: 'https://storage.justimmo.at/file/7duTPEiZi4ofuEgpSuNPIX.jpeg',
      original_filename: 'Schlafzimmer.jpeg',
      title: '',
      description: '',
      sort_order: 2,
      uploaded_at: '2025-03-17T13:13:41+01:00',
      visibility: 0,
      active: true,
      group: {
        id: 1,
      },
      original_filesize: 601655,
      mime_type: 'image/jpeg',
      width: 1792,
      height: 1024,
      thumbnails: [
        {
          name: 'small',
          url: 'https://storage.justimmo.at/thumb/26d3cd2c8d6f762057a110028d432ffc/fc_h300_w100/7duTPEiZi4ofuEgpSuNPIX.jpeg',
        },
        {
          name: 'fullhd',
          url: 'https://storage.justimmo.at/thumb/99b4d3b527bb021016b8970d82ba1f41/fc_h1080_w1920/7duTPEiZi4ofuEgpSuNPIX.jpeg',
        },
        {
          name: 'fullhd_branded',
          url: 'https://storage.justimmo.at/thumb/61fc299bec2d554f03216064dda2c49d/Fc_Ltl_Ms58xncItneAknwZKGdek0.png_fc_h1080_w1920/7duTPEiZi4ofuEgpSuNPIX.jpeg',
        },
      ],
      additionalProperties: {},
    },
    {
      type: 0,
      storage_key: '5vwKSbMCFYhqxhDruni150.jpeg',
      url: 'https://storage.justimmo.at/file/5vwKSbMCFYhqxhDruni150.jpeg',
      original_filename: 'Gäste-WC.jpeg',
      title: '',
      description: '',
      sort_order: 6,
      uploaded_at: '2025-03-17T13:13:40+01:00',
      visibility: 0,
      active: true,
      group: {
        id: 1,
      },
      original_filesize: 409588,
      mime_type: 'image/jpeg',
      width: 1792,
      height: 1024,
      thumbnails: [
        {
          name: 'small',
          url: 'https://storage.justimmo.at/thumb/134fe4fb09c15061960fedd4d44c1ce7/fc_h300_w100/5vwKSbMCFYhqxhDruni150.jpeg',
        },
        {
          name: 'fullhd',
          url: 'https://storage.justimmo.at/thumb/bfb25ca7161a3b6b16fbad406f937b2e/fc_h1080_w1920/5vwKSbMCFYhqxhDruni150.jpeg',
        },
        {
          name: 'fullhd_branded',
          url: 'https://storage.justimmo.at/thumb/5b09bb6b8fc0685be2cae6b47d954c6e/Fc_Ltl_Ms58xncItneAknwZKGdek0.png_fc_h1080_w1920/5vwKSbMCFYhqxhDruni150.jpeg',
        },
      ],
      additionalProperties: {},
    },
    {
      type: 0,
      storage_key: '1b8dQWIKftFrCggMUtdpQI.jpeg',
      url: 'https://storage.justimmo.at/file/1b8dQWIKftFrCggMUtdpQI.jpeg',
      original_filename: 'Balkon.jpeg',
      title: '',
      description: '',
      sort_order: 1,
      uploaded_at: '2025-03-17T13:13:39+01:00',
      visibility: 0,
      active: true,
      group: {
        id: 1,
      },
      original_filesize: 507542,
      mime_type: 'image/jpeg',
      width: 1792,
      height: 1024,
      thumbnails: [
        {
          name: 'small',
          url: 'https://storage.justimmo.at/thumb/0c1948fc26fcc3d477a1a7ffcda8c3d5/fc_h300_w100/1b8dQWIKftFrCggMUtdpQI.jpeg',
        },
        {
          name: 'fullhd',
          url: 'https://storage.justimmo.at/thumb/c2a223bf00623c261dd0cccd5e2c8db3/fc_h1080_w1920/1b8dQWIKftFrCggMUtdpQI.jpeg',
        },
        {
          name: 'fullhd_branded',
          url: 'https://storage.justimmo.at/thumb/f223042c2ddf45b50a7aa029533c542c/Fc_Ltl_Ms58xncItneAknwZKGdek0.png_fc_h1080_w1920/1b8dQWIKftFrCggMUtdpQI.jpeg',
        },
      ],
      additionalProperties: {},
    },
    {
      type: 0,
      storage_key: '6jeeeD2vetb0ajerA0nrA4.jpeg',
      url: 'https://storage.justimmo.at/file/6jeeeD2vetb0ajerA0nrA4.jpeg',
      original_filename: 'Badezimmer.jpeg',
      title: '',
      description: '',
      sort_order: 5,
      uploaded_at: '2025-03-17T13:13:39+01:00',
      visibility: 0,
      active: true,
      group: {
        id: 1,
      },
      original_filesize: 488197,
      mime_type: 'image/jpeg',
      width: 1792,
      height: 1024,
      thumbnails: [
        {
          name: 'small',
          url: 'https://storage.justimmo.at/thumb/30c7bc3675063a5f2eff7b3bfb296d5f/fc_h300_w100/6jeeeD2vetb0ajerA0nrA4.jpeg',
        },
        {
          name: 'fullhd',
          url: 'https://storage.justimmo.at/thumb/7211d5e83af83da7c14239966838f819/fc_h1080_w1920/6jeeeD2vetb0ajerA0nrA4.jpeg',
        },
        {
          name: 'fullhd_branded',
          url: 'https://storage.justimmo.at/thumb/26176b07b9f3a88ce182752612a9d13d/Fc_Ltl_Ms58xncItneAknwZKGdek0.png_fc_h1080_w1920/6jeeeD2vetb0ajerA0nrA4.jpeg',
        },
      ],
      additionalProperties: {},
    },
    {
      type: 0,
      storage_key: '5GUPTTqnTzZbVNLi40SvMr.jpeg',
      url: 'https://storage.justimmo.at/file/5GUPTTqnTzZbVNLi40SvMr.jpeg',
      original_filename: 'Arbeitszimmer.jpeg',
      title: '',
      description: '',
      sort_order: 4,
      uploaded_at: '2025-03-17T13:13:38+01:00',
      visibility: 0,
      active: true,
      group: {
        id: 1,
      },
      original_filesize: 557125,
      mime_type: 'image/jpeg',
      width: 1792,
      height: 1024,
      thumbnails: [
        {
          name: 'small',
          url: 'https://storage.justimmo.at/thumb/a16eefe6bdc40fafc39a0fbe7f8fe951/fc_h300_w100/5GUPTTqnTzZbVNLi40SvMr.jpeg',
        },
        {
          name: 'fullhd',
          url: 'https://storage.justimmo.at/thumb/12a1d263e0a0a88ca6fa3047c181f2eb/fc_h1080_w1920/5GUPTTqnTzZbVNLi40SvMr.jpeg',
        },
        {
          name: 'fullhd_branded',
          url: 'https://storage.justimmo.at/thumb/b11ca3d50dd73e6625b06e0812c098fe/Fc_Ltl_Ms58xncItneAknwZKGdek0.png_fc_h1080_w1920/5GUPTTqnTzZbVNLi40SvMr.jpeg',
        },
      ],
      additionalProperties: {},
    },
    {
      type: 0,
      storage_key: '2ODNPmZUzpcxkQ37WuPRJk.jpeg',
      url: 'https://storage.justimmo.at/file/2ODNPmZUzpcxkQ37WuPRJk.jpeg',
      original_filename: 'Abstellraum.jpeg',
      title: '',
      description: '',
      sort_order: 7,
      uploaded_at: '2025-03-17T13:13:38+01:00',
      visibility: 0,
      active: true,
      group: {
        id: 1,
      },
      original_filesize: 392668,
      mime_type: 'image/jpeg',
      width: 1792,
      height: 1024,
      thumbnails: [
        {
          name: 'small',
          url: 'https://storage.justimmo.at/thumb/86fb3fc0903009c80031ee5d918e1de3/fc_h300_w100/2ODNPmZUzpcxkQ37WuPRJk.jpeg',
        },
        {
          name: 'fullhd',
          url: 'https://storage.justimmo.at/thumb/5c156f7cf14738ac439e283d95753136/fc_h1080_w1920/2ODNPmZUzpcxkQ37WuPRJk.jpeg',
        },
        {
          name: 'fullhd_branded',
          url: 'https://storage.justimmo.at/thumb/fd58230916a49b6507ea9b312e6db2e3/Fc_Ltl_Ms58xncItneAknwZKGdek0.png_fc_h1080_w1920/2ODNPmZUzpcxkQ37WuPRJk.jpeg',
        },
      ],
      additionalProperties: {},
    },
    {
      type: 0,
      storage_key: '5O4NZZKigUCZwIiUrVaZiE.jpg',
      url: 'https://storage.justimmo.at/file/5O4NZZKigUCZwIiUrVaZiE.jpg',
      original_filename: 'Plan.jpg',
      title: '',
      description: '',
      sort_order: 0,
      uploaded_at: '2025-03-15T09:29:35+01:00',
      visibility: 0,
      active: true,
      group: {
        id: 2,
      },
      original_filesize: 375604,
      mime_type: 'image/jpeg',
      width: 2475,
      height: 3500,
      thumbnails: [
        {
          name: 'small',
          url: 'https://storage.justimmo.at/thumb/d352981d5454968113b4c0fe583d7a10/fc_h300_w100/5O4NZZKigUCZwIiUrVaZiE.jpg',
        },
        {
          name: 'fullhd',
          url: 'https://storage.justimmo.at/thumb/ea233c3329d4b68ea9981f5894e95782/fc_h1080_w1920/5O4NZZKigUCZwIiUrVaZiE.jpg',
        },
        {
          name: 'fullhd_branded',
          url: 'https://storage.justimmo.at/thumb/09e96d94ab1d3c1989a0fd44d388a111/Fc_Ltl_Ms58xncItneAknwZKGdek0.png_fc_h1080_w1920/5O4NZZKigUCZwIiUrVaZiE.jpg',
        },
      ],
      additionalProperties: {},
    },
    {
      type: 1,
      storage_key: '2HEWx3WioLZ6TswdcNLC0M.pdf',
      url: 'https://api.justimmo.at/v1/file/2HEWx3WioLZ6TswdcNLC0M.pdf',
      original_filename: 'Energieausweis.pdf',
      title: '',
      description: '',
      sort_order: 99999,
      uploaded_at: '2025-03-10T11:22:06+01:00',
      visibility: 1,
      active: true,
      group: {
        id: 39,
      },
      original_filesize: 571830,
      mime_type: 'application/pdf',
      width: 0,
      height: 0,
      thumbnails: null,
      additionalProperties: {},
    },
    {
      type: 1,
      storage_key: '3FkCfIW1o5r5Bleickr6Y0.pdf',
      url: 'https://api.justimmo.at/v1/file/3FkCfIW1o5r5Bleickr6Y0.pdf',
      original_filename: 'Grundbuchauszug.pdf',
      title: '',
      description: '',
      sort_order: 99999,
      uploaded_at: '2025-03-10T11:22:06+01:00',
      visibility: 1,
      active: true,
      group: {
        id: 39,
      },
      original_filesize: 254463,
      mime_type: 'application/pdf',
      width: 0,
      height: 0,
      thumbnails: null,
      additionalProperties: {},
    },
    {
      type: 1,
      storage_key: '6yNGnnTP5sIvaXQV5swG9J.pdf',
      url: 'https://api.justimmo.at/v1/file/6yNGnnTP5sIvaXQV5swG9J.pdf',
      original_filename: 'Legitimation.pdf',
      title: '',
      description: '',
      sort_order: 99999,
      uploaded_at: '2025-03-10T11:22:05+01:00',
      visibility: 1,
      active: true,
      group: {
        id: 39,
      },
      original_filesize: 118031,
      mime_type: 'application/pdf',
      width: 0,
      height: 0,
      thumbnails: null,
      additionalProperties: {},
    },
    {
      type: 1,
      storage_key: 'jxZzMIHOGZdw0x1Qof5fJ.pdf',
      url: 'https://api.justimmo.at/v1/file/jxZzMIHOGZdw0x1Qof5fJ.pdf',
      original_filename: 'Vermittlungsauftrag.pdf',
      title: '',
      description: '',
      sort_order: 99999,
      uploaded_at: '2025-03-10T11:22:05+01:00',
      visibility: 1,
      active: true,
      group: {
        id: 39,
      },
      original_filesize: 166432,
      mime_type: 'application/pdf',
      width: 0,
      height: 0,
      thumbnails: null,
      additionalProperties: {},
    },
    {
      type: 1,
      storage_key: '2Y8XIBJ06Dw1mJU2DVVWn1.pdf',
      url: 'https://api.justimmo.at/v1/file/2Y8XIBJ06Dw1mJU2DVVWn1.pdf',
      original_filename: 'Betriebskostenvorschreibung.pdf',
      title: '',
      description: '',
      sort_order: 99999,
      uploaded_at: '2025-03-10T11:22:05+01:00',
      visibility: 1,
      active: true,
      group: {
        id: 39,
      },
      original_filesize: 109917,
      mime_type: 'application/pdf',
      width: 0,
      height: 0,
      thumbnails: null,
      additionalProperties: {},
    },
    {
      type: 0,
      storage_key: '3dNiKBVWrudeDSxuqNPE57.png',
      url: 'https://storage.justimmo.at/file/3dNiKBVWrudeDSxuqNPE57.png',
      original_filename: 'Lageplan.png',
      title: '',
      description: '',
      sort_order: 1,
      uploaded_at: '2025-03-04T10:32:01+01:00',
      visibility: 0,
      active: true,
      group: {
        id: 2,
      },
      original_filesize: 571116,
      mime_type: 'image/png',
      width: 2048,
      height: 1360,
      thumbnails: [
        {
          name: 'small',
          url: 'https://storage.justimmo.at/thumb/eb2640f9d36e5478da4495921e834636/fc_h300_w100/3dNiKBVWrudeDSxuqNPE57.png',
        },
        {
          name: 'fullhd',
          url: 'https://storage.justimmo.at/thumb/fa85dc78fcca559e5aa7b29e84031e8d/fc_h1080_w1920/3dNiKBVWrudeDSxuqNPE57.png',
        },
        {
          name: 'fullhd_branded',
          url: 'https://storage.justimmo.at/thumb/c91b34ed14500e4c001dcf55534d67a8/Fc_Ltl_Ms58xncItneAknwZKGdek0.png_fc_h1080_w1920/3dNiKBVWrudeDSxuqNPE57.png',
        },
      ],
      additionalProperties: {},
    },
  ],
  internal_files: [],
  texts: {
    label: '',
    title: [
      {
        value: 'Luxuriöse 4-Zimmer-Wohnung in 1030 Wien – Erstbezug mit Balkon und Top-Ausstattung!',
        locale: 'de',
        additionalProperties: {},
      },
    ],
    location: [
      {
        value:
          'Diese charmante Wohnung im 3. Bezirk von Wien besticht durch ihre zentrale Lage. In unmittelbarer Nähe finden Sie alles, was das Herz begehrt: Ärzte, Apotheken, Kliniken und Schulen, einschließlich Hochschulen. Zahlreiche Supermärkte, Bäckereien und ein Einkaufszentrum sorgen für eine bequeme Nahversorgung. Öffentliche Verkehrsanbindungen wie Bus, U-Bahn und Straßenbahn sind fußläufig erreichbar, ebenso wie Banken, Post und Polizeidienststellen. Ein perfekter Ort zum Leben!',
        locale: 'de',
        additionalProperties: {},
      },
    ],
    description: [
      {
        value:
          '<p>Willkommen in Ihrem neuen Zuhause im Herzen von 1030 Wien! Diese beeindruckende Wohnung bietet Ihnen nicht nur eine erstklassige Lage, sondern auch eine Fülle an Annehmlichkeiten, die das Leben in der Stadt so angenehm machen.</p>\r\n\r\n<p>Mit einer großzügigen Fläche von 90 m² und drei gut geschnittenen Zimmern ist diese Immobilie der ideale Rückzugsort für Familien, Paare oder alle, die viel Platz und Komfort schätzen. Der traumhafte Stadtblick von Ihrem Südwestbalkon wird Sie täglich begeistern und lädt dazu ein, den Abend bei einem Glas Wein ausklingen zu lassen.</p>\r\n\r\n<p>Die Wohnung wurde mit hochwertigen Materialien ausgestattet, darunter edles Parkett und eine moderne Fußbodenheizung, die für ein behagliches Wohnklima sorgt. Die offene Einbauküche ist nicht nur funktional, sondern auch ein stilvoller Mittelpunkt, der das Kochen zu einem Vergnügen macht. Ob Sie ein schnelles Frühstück zubereiten oder ein ausgiebiges Dinner für Freunde planen – hier wird jeder Moment zum Erlebnis.</p>\r\n\r\n<p>Die hervorragende Verkehrsanbindung in der Umgebung ist ein weiterer Pluspunkt dieser Immobilie. Mit Bus, U-Bahn, Straßenbahn und dem Bahnhof in unmittelbarer Nähe sind Sie optimal vernetzt und gelangen schnell an Ihr Ziel – sei es zur Arbeit, zum Einkaufen oder zu Freizeitaktivitäten. </p>\r\n\r\n<p>Die Nachbarschaft bietet Ihnen alles, was Sie für den täglichen Bedarf benötigen. Ärzte, Apotheken, Kliniken und Krankenhäuser sind in der Nähe, ebenso wie Schulen, Kindergärten und Universitäten. Supermärkte, Bäckereien und ein Einkaufszentrum befinden sich ebenfalls in der Umgebung, sodass Sie in kürzester Zeit alles erreichen können, was Sie benötigen.</p>\r\n\r\n<p>Lassen Sie sich diese einmalige Gelegenheit nicht entgehen! Diese Wohnung ist mehr als nur ein Ort zum Wohnen – sie ist ein Lebensraum, der Ihnen Komfort, Stil und eine ausgezeichnete Lebensqualität bietet. Kontaktieren Sie uns noch heute für einen Besichtigungstermin und überzeugen Sie sich selbst von diesem wunderbaren Angebot in 1030 Wien!</p>',
        locale: 'de',
        additionalProperties: {},
      },
    ],
    description_expose: [],
    additionalProperties: {},
  },
  energy_performance_certification: {
    energy_performance: {
      value: 1.9,
      class: 1,
      additionalProperties: {},
    },
    heating_demand: {
      value: 33.3,
      class: 2,
      additionalProperties: {},
    },
    valid_until: '2028-01-13T00:00:00+00:00',
    auto_disclaimer: false,
    additionalProperties: {},
  },
  features: [
    {
      group_label: 'Boden',
      items: [
        {
          id: 7,
          label: 'Parkett',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      group_label: 'Heizungsart',
      items: [
        {
          id: 18,
          label: 'Fußbodenheizung',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      group_label: 'Küche',
      items: [
        {
          id: 22,
          label: 'Einbauküche',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      group_label: 'Fahrstuhl',
      items: [
        {
          id: 25,
          label: 'Personenaufzug',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      group_label: 'Balkon',
      items: [
        {
          id: 28,
          label: 'Südbalkon / -terrasse',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      group_label: 'Bad',
      items: [
        {
          id: 35,
          label: 'Dusche',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      group_label: 'Stellplatzart',
      items: [
        {
          id: 46,
          label: 'Parkplatz',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      group_label: 'Extras',
      items: [
        {
          id: 49,
          label: 'Alarmanlage',
          tenant_id: null,
          additionalProperties: {},
        },
        {
          id: 57,
          label: 'Sicherheitskamera',
          tenant_id: null,
          additionalProperties: {},
        },
        {
          id: 112,
          label: 'Fahrradraum',
          tenant_id: null,
          additionalProperties: {},
        },
        {
          id: 113,
          label: 'Abstellraum',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      group_label: 'Belüftung',
      items: [
        {
          id: 78,
          label: 'Klimaanlage',
          tenant_id: null,
          additionalProperties: {},
        },
        {
          id: 936,
          label: 'kontrollierte Wohnraumlüftung',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      group_label: 'Fenster',
      items: [
        {
          id: 154,
          label: 'Außenliegender Sonnenschutz',
          tenant_id: null,
          additionalProperties: {},
        },
        {
          id: 157,
          label: 'Öffenbare Fenster',
          tenant_id: null,
          additionalProperties: {},
        },
        {
          id: 670,
          label: 'Doppel- / Mehrfachverglasung',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      group_label: 'Beleuchtung',
      items: [
        {
          id: 161,
          label: 'Deckenleuchten',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      group_label: 'Ausblick',
      items: [
        {
          id: 664,
          label: 'Stadtblick',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      group_label: 'Bauweise',
      items: [
        {
          id: 945,
          label: 'Ziegel',
          tenant_id: null,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
  ],
  links: [],
  residential_aggregation_data: null,
  commission: {
    prospect: {
      text_value: '3% des Kaufpreises zzgl. 20% USt.',
    },
  },
  condition_assessment: null,
  is_public: true,
  agency_agreement: {
    valid_from: null,
    valid_until: null,
    agency_agreement_type: 0,
    agreement_method: null,
  },
  additionalProperties: {
    284621766:
      '{"ActivityTypeId":4,"ActivityTypeName":"E-Mail (Angebot via Justimmo)","Comment":"mit Adressen, mit Preisen, mit Links, mit folgenden Dateien: \\u0022960-71130_-_Wohnung_-_Kauf_-_1030_-_Expose\\u0022, \\u00222024_04_Maklervertrag und AGB.pdf\\u0022, Kaufpreis: 1.990.000,00\\u00A0\\u20AC","Created_at":"2025-03-12T14:26:56+01:00","Offertext":"\\u003Ch2\\u003ESehr geehrte(r) Frau/Herr Mustermann!\\u003C/h2\\u003E\\u003Ch2\\u003EHiermit \\u00FCbermitteln wir Ihnen ein Immobilienangebot.\\u003C/h2\\u003E\\u003Cp\\u003E\\u00DCber den Button \\u201EZum Immobilienangebot gelangen Sie direkt zur Detailseite, auf der Sie weitere Informationen sowie alle relevanten Dokumente, wie das Immobilienexpos\\u00E9, herunterladen k\\u00F6nnen. Bei Fragen steht Ihnen die dort genannte Immobilienmakler:in gerne zur Verf\\u00FCgung.\\u003C/p\\u003E\\u003Cp\\u003Ehttps://apps.justimmo.at/nachricht/27365139/29704465/82904b32524355aff3fc0533f72a09b9f20fc6f4/immobilie\\u003C/p\\u003E","Files":[{"Type":1,"Storage_key":"3o9Ba5p5iBgSKZhVeVeVoH.pdf","Url":"https://api.justimmo.at/v1/file/3o9Ba5p5iBgSKZhVeVeVoH.pdf","Original_filename":"960-71130_-_Wohnung_-_Kauf_-_1030_-_Expose.pdf","Title":"960-71130_-_Wohnung_-_Kauf_-_1030_-_Expose","Description":"","Sort_order":null,"Uploaded_at":"2025-03-12T14:26:59+01:00","Visibility":1,"Active":true,"Group":null,"Original_filesize":9992741,"Mime_type":"application/pdf","Width":0,"Height":0,"Thumbnails":null,"AdditionalProperties":{}},{"Type":1,"Storage_key":"2ZSazQaCQ6lS3HejGtfdjk.pdf","Url":"https://storage.justimmo.at/file/2ZSazQaCQ6lS3HejGtfdjk.pdf","Original_filename":"2024_04_Maklervertrag und AGB.pdf","Title":"","Description":"","Sort_order":null,"Uploaded_at":"2025-02-17T09:26:51+01:00","Visibility":0,"Active":true,"Group":null,"Original_filesize":106852,"Mime_type":"application/pdf","Width":0,"Height":0,"Thumbnails":null,"AdditionalProperties":{}}],"From":"0001-01-01 00:00:00Z","To":"0001-01-01 00:00:00Z"}',
    284621781:
      '{"ActivityTypeId":4,"ActivityTypeName":"E-Mail (Angebot via Justimmo)","Comment":"mit Adressen, mit Preisen, mit Links, mit folgenden Dateien: \\u0022960-71130_-_Wohnung_-_Kauf_-_1030_-_Expose\\u0022, \\u00222024_04_Maklervertrag und AGB.pdf\\u0022, Kaufpreis: 1.990.000,00\\u00A0\\u20AC","Created_at":"2025-03-12T14:27:02+01:00","Offertext":"\\u003Ch2\\u003ESehr geehrter Herr Mustermann!\\u003C/h2\\u003E\\u003Ch2\\u003EHiermit \\u00FCbermitteln wir Ihnen ein Immobilienangebot.\\u003C/h2\\u003E\\u003Cp\\u003E\\u00DCber den Button \\u201EZum Immobilienangebot gelangen Sie direkt zur Detailseite, auf der Sie weitere Informationen sowie alle relevanten Dokumente, wie das Immobilienexpos\\u00E9, herunterladen k\\u00F6nnen. Bei Fragen steht Ihnen die dort genannte Immobilienmakler:in gerne zur Verf\\u00FCgung.\\u003C/p\\u003E\\u003Cp\\u003Ehttps://apps.justimmo.at/nachricht/27365139/33107941/abf4b17a4b1084ace6b5276f7e4c1b5e99e920fb/immobilie\\u003C/p\\u003E","Files":[{"Type":1,"Storage_key":"49xHDkgPggg4YKUjCcQVbn.pdf","Url":"https://api.justimmo.at/v1/file/49xHDkgPggg4YKUjCcQVbn.pdf","Original_filename":"960-71130_-_Wohnung_-_Kauf_-_1030_-_Expose.pdf","Title":"960-71130_-_Wohnung_-_Kauf_-_1030_-_Expose","Description":"","Sort_order":null,"Uploaded_at":"2025-03-12T14:27:04+01:00","Visibility":1,"Active":true,"Group":null,"Original_filesize":9992717,"Mime_type":"application/pdf","Width":0,"Height":0,"Thumbnails":null,"AdditionalProperties":{}},{"Type":1,"Storage_key":"2ZSazQaCQ6lS3HejGtfdjk.pdf","Url":"https://storage.justimmo.at/file/2ZSazQaCQ6lS3HejGtfdjk.pdf","Original_filename":"2024_04_Maklervertrag und AGB.pdf","Title":"","Description":"","Sort_order":null,"Uploaded_at":"2025-02-17T09:26:51+01:00","Visibility":0,"Active":true,"Group":null,"Original_filesize":106852,"Mime_type":"application/pdf","Width":0,"Height":0,"Thumbnails":null,"AdditionalProperties":{}}],"From":"0001-01-01 00:00:00Z","To":"0001-01-01 00:00:00Z"}',
    284623371:
      '{"ActivityTypeId":4,"ActivityTypeName":"E-Mail (Angebot via Justimmo)","Comment":"Preisreduktion - E-Mail Anbot / , mit Adressen, mit Preisen, mit folgenden Dateien: \\u0022960-71130_-_Wohnung_-_Kauf_-_1030_-_Expose\\u0022, \\u00222024_04_Maklervertrag und AGB.pdf\\u0022, Kaufpreis: 1.990.000,00\\u00A0\\u20AC","Created_at":"2025-03-12T14:36:29+01:00","Offertext":"\\u003Cp\\u003E\\u003Cspan style=\\u0022font-size:14px;\\u0022\\u003ESehr geehrte(r) Frau/Herr Mustermann,\\u003C/span\\u003E\\u003C/p\\u003E\\u003Cp\\u003Ewir erlauben uns, Sie \\u00FCber die Preisreduktion dieser Immobilie zu informieren.\\u003C/p\\u003E\\u003Cp\\u003EDas Expos\\u00E9 mit dem aktuellen Preis finden Sie im Anhang.\\u003C/p\\u003E\\u003Cp\\u003EF\\u00FCr weitere Fragen stehen wir Ihnen gerne zur Verf\\u00FCgung!\\u003C/p\\u003E\\u003Cp\\u003Ehttps://apps.justimmo.at/nachricht/27365352/29891197/54156820b4b1a2e367b940f9f595692cf821f270/immobilie\\u003C/p\\u003E","Files":[{"Type":1,"Storage_key":"21ZRzMVj8uhDs2eLkA4TnZ.pdf","Url":"https://api.justimmo.at/v1/file/21ZRzMVj8uhDs2eLkA4TnZ.pdf","Original_filename":"960-71130_-_Wohnung_-_Kauf_-_1030_-_Expose.pdf","Title":"960-71130_-_Wohnung_-_Kauf_-_1030_-_Expose","Description":"","Sort_order":null,"Uploaded_at":"2025-03-12T14:36:30+01:00","Visibility":1,"Active":true,"Group":null,"Original_filesize":9993954,"Mime_type":"application/pdf","Width":0,"Height":0,"Thumbnails":null,"AdditionalProperties":{}},{"Type":1,"Storage_key":"2ZSazQaCQ6lS3HejGtfdjk.pdf","Url":"https://storage.justimmo.at/file/2ZSazQaCQ6lS3HejGtfdjk.pdf","Original_filename":"2024_04_Maklervertrag und AGB.pdf","Title":"","Description":"","Sort_order":null,"Uploaded_at":"2025-02-17T09:26:51+01:00","Visibility":0,"Active":true,"Group":null,"Original_filesize":106852,"Mime_type":"application/pdf","Width":0,"Height":0,"Thumbnails":null,"AdditionalProperties":{}}],"From":"0001-01-01 00:00:00Z","To":"0001-01-01 00:00:00Z"}',
    285177903:
      '{"ActivityTypeId":34,"ActivityTypeName":"Objekt\\u00FCbergabe","Comment":"Der Termin f\\u00FCr die Schl\\u00FCssel\\u00FCbergabe findet an 01.04.2025 um 13:00 Uhr in der Wohnung statt.","Created_at":"2025-03-17T10:29:22+01:00","Offertext":null,"Files":[],"From":"2025-04-01 11:00:00Z","To":"0001-01-01 00:00:00Z"}',
    285178275:
      '{"ActivityTypeId":61,"ActivityTypeName":"Beh\\u00F6rdenweg","Comment":"Ich habe beim zust\\u00E4ndigen Amt die Pl\\u00E4ne eingeholt. Ich habe Sie Ihnen ins immo-drive gestellt.\\r\\nFreundliche Gr\\u00FC\\u00DFe Sabine Hofer","Created_at":"2025-03-17T10:30:36+01:00","Offertext":null,"Files":[],"From":"2025-02-09 23:00:00Z","To":"0001-01-01 00:00:00Z"}',
    285178416:
      '{"ActivityTypeId":33,"ActivityTypeName":"Verkaufstafel","Comment":"Ich habe eine Verkaufstafel am Fenster in Ihrer Wohnung befestigt. Freundliche Gr\\u00FC\\u00DFe Sabine Hofer","Created_at":"2025-03-17T10:31:17+01:00","Offertext":null,"Files":[],"From":"2025-02-10 23:00:00Z","To":"0001-01-01 00:00:00Z"}',
    285178794:
      '{"ActivityTypeId":8,"ActivityTypeName":"Besichtigung","Comment":"Bereits die erste Besichtigung verlief sehr vielversprechend. Ich freue mich auf der R\\u00FCckmeldung der Interessentin. Besonders gut gef\\u00E4llt ihr die Lage und der Grundriss der Wohnung. Ich halte Sie weiterhin auf dem Laufenden! Freundliche Gr\\u00FC\\u00DFe Sabine Hofer","Created_at":"2025-03-17T10:33:18+01:00","Offertext":null,"Files":[],"From":"2025-02-12 09:00:00Z","To":"0001-01-01 00:00:00Z"}',
    285179715:
      '{"ActivityTypeId":8,"ActivityTypeName":"Besichtigung","Comment":"Heute war ich nun wieder f\\u00FCr eine Besichtigung vor Ort. Es lief ganz gut und die Wohnung hat einen positiven Eindruck hinterlassen.","Created_at":"2025-03-17T10:37:36+01:00","Offertext":null,"Files":[],"From":"2025-02-27 14:00:00Z","To":"0001-01-01 00:00:00Z"}',
    285179931:
      '{"ActivityTypeId":6,"ActivityTypeName":"Aushang","Comment":"Es h\\u00E4ngen nun Immobilienangebote zu Ihrer Immobilie in allen Erste Bank Filialen des 2. und 3. Bezirk. Freundliche Gr\\u00FC\\u00DFe Sabine Hofer","Created_at":"2025-03-17T10:38:28+01:00","Offertext":null,"Files":[],"From":"2025-02-28 11:00:00Z","To":"0001-01-01 00:00:00Z"}',
    285180150:
      '{"ActivityTypeId":8,"ActivityTypeName":"Besichtigung","Comment":"Besichtigung lief gut und es gibt eine Kaufabsicht. Ich habe den Kunden nun auf Wunsch an unsere Finanzierer von der Erste Bank weitergeleitet. Die sind immer sehr schnell. Ich halte Sie auf dem Laufenden! Freundliche Gr\\u00FC\\u00DFe Sabine Hofer","Created_at":"2025-03-17T10:39:41+01:00","Offertext":null,"Files":[],"From":"2025-03-02 23:00:00Z","To":"0001-01-01 00:00:00Z"}',
    285180825:
      '{"ActivityTypeId":8,"ActivityTypeName":"Besichtigung","Comment":"Es war die zweite Besichtigung mit der Kundin. Diesmal hat sie einen Sachverst\\u00E4ndigen mitgebracht, f\\u00FCr die Begutachtung des Kellers bzgl. Feuchtigkeit. Alles top - sagte der. Die Finanzierung konnte Sie bereits mit unserem Finanzierer der Erste Bank abkl\\u00E4ren. Hier funktioniert auch alles. Es l\\u00E4uft also nach Plan! Die Kundin bat mich, ich ein Kaufanbotsdokument zu \\u00FCbermitteln. Ich hoffe ich kann mich bald mit positiven Neuigkeiten bei Ihnen melden. Daumen dr\\u00FCcken! Freundliche Gr\\u00FC\\u00DFe Sabine Hofer","Created_at":"2025-03-17T10:42:24+01:00","Offertext":null,"Files":[],"From":"2025-03-12 10:30:00Z","To":"0001-01-01 00:00:00Z"}',
    285181437:
      '{"ActivityTypeId":10,"ActivityTypeName":"Inserat","Comment":"Ein Inserat Ihrer Immobilie ist nun für die kommende Ausgabe des sREAL WOHNEN Magazins eingeplant. Sie erhalten es bei uns direkt (B\\u00FCro der s Real am Rochusmarkt oder auch alle anderen Standorte in \\u00D6sterreich), in Ihrer Erste Bank Filiale oder sie bl\\u00E4ttern es online durch. Freundliche Gr\\u00FC\\u00DFe Sabine Hofer","Created_at":"2025-03-17T10:45:46+01:00","Offertext":null,"Files":[],"From":"2025-02-13 09:00:00Z","To":"0001-01-01 00:00:00Z"}',
    285181632:
      '{"ActivityTypeId":10,"ActivityTypeName":"Inserat","Comment":"Ich habe Ihre Immobilie nun wie besprochen im \\u0022Immofokus\\u0022 inseriert. Freundliche Gr\\u00FC\\u00DFe Sabine Hofer","Created_at":"2025-03-17T10:46:48+01:00","Offertext":null,"Files":[],"From":"2025-02-17 07:00:00Z","To":"0001-01-01 00:00:00Z"}',
    285181857:
      '{"ActivityTypeId":8,"ActivityTypeName":"Besichtigung","Comment":"Heute Abend fand eine sehr vielversprechende Besichtigung statt. Ich melde mich, sobald es Neuigkeiten gibt. Freundliche Gr\\u00FC\\u00DFe Sabine Hofer","Created_at":"2025-03-17T10:47:52+01:00","Offertext":null,"Files":[],"From":"2025-02-25 16:00:00Z","To":"0001-01-01 00:00:00Z"}',
    285186288:
      '{"ActivityTypeId":8,"ActivityTypeName":"Besichtigung","Comment":"Heute hat ebenfalls wieder eine sehr nette Besichtigung stattgefunden. Die Familie besichtig die Woche noch 3andere Immobilien und meldet sich dann bei mir. Ich halte Sie auf dem Laufenden. Freundliche Gr\\u00FC\\u00DFe Sabine Hofer","Created_at":"2025-03-17T11:05:29+01:00","Offertext":null,"Files":[],"From":"2025-02-13 23:00:00Z","To":"0001-01-01 00:00:00Z"}',
    285186594:
      '{"ActivityTypeId":1196,"ActivityTypeName":"Online-Besichtigung","Comment":"Heute hat eine Online-Besichtigung stattgefunden, da der potentielle Kunde aktuell noch im Ausland lebt und plant in den n\\u00E4chsten Monaten mit seiner Familie aus beruflichen Gr\\u00FCnden nach Wien zu ziehen.","Created_at":"2025-03-17T11:07:09+01:00","Offertext":null,"Files":[],"From":"2025-02-18 23:00:00Z","To":"0001-01-01 00:00:00Z"}',
    room_layout: null,
    preview_plan: {
      storage_key: [],
      sizes: [[[]], [[]], [[]]],
    },
    year_of_last_comprehensive_renovation: null,
    realty_condition: {
      id: [],
      name: [],
    },
    building_condition: null,
    vendor_economic_relationship: 'none',
    dual_brokerage: false,
    automatic_hits: true,
    land_register_entries: [],
    ownership_type: null,
    furnishing: null,
    noise_level: null,
    location_assessment: null,
    floors: {
      count_floors: [],
      count_attic_floors: [],
      mezzanine: [],
    },
    ImmoLiveHighestBid: 0,
  },
};

export const abgeberimmo_phase4_parsed = parseImmo(abgeberimmo_phase4);

export const abgeberimmo_phase4_categories = {
  groups: [
    {
      id: 'traffic',
      name: 'Verkehr',
      categories: [
        {
          id: 'bus',
          name: 'Bus',
          distance: 66,
          additionalProperties: {},
        },
        {
          id: 'subway',
          name: 'U-Bahn',
          distance: 239,
          additionalProperties: {},
        },
        {
          id: 'tram',
          name: 'Straßenbahn',
          distance: 564,
          additionalProperties: {},
        },
        {
          id: 'railway_station',
          name: 'Bahnhof',
          distance: 278,
          additionalProperties: {},
        },
        {
          id: 'motorway_junction',
          name: 'Autobahnanschluss',
          distance: 1293,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      id: 'local_supply',
      name: 'Nahversorgung',
      categories: [
        {
          id: 'supermarket',
          name: 'Supermarkt',
          distance: 28,
          additionalProperties: {},
        },
        {
          id: 'bakery',
          name: 'Bäckerei',
          distance: 151,
          additionalProperties: {},
        },
        {
          id: 'mall',
          name: 'Einkaufszentrum',
          distance: 204,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      id: 'health',
      name: 'Gesundheit',
      categories: [
        {
          id: 'doctors',
          name: 'Arzt',
          distance: 210,
          additionalProperties: {},
        },
        {
          id: 'pharmacy',
          name: 'Apotheke',
          distance: 216,
          additionalProperties: {},
        },
        {
          id: 'clinic',
          name: 'Klinik',
          distance: 346,
          additionalProperties: {},
        },
        {
          id: 'hospital',
          name: 'Krankenhaus',
          distance: 294,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      id: 'children_and_school',
      name: 'Kinder & Schulen',
      categories: [
        {
          id: 'school',
          name: 'Schule',
          distance: 225,
          additionalProperties: {},
        },
        {
          id: 'kindergarten',
          name: 'Kindergarten',
          distance: 263,
          additionalProperties: {},
        },
        {
          id: 'university',
          name: 'Universität',
          distance: 896,
          additionalProperties: {},
        },
        {
          id: 'college',
          name: 'Höhere Schule',
          distance: 317,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
    {
      id: 'other',
      name: 'Sonstige',
      categories: [
        {
          id: 'atm',
          name: 'Geldautomat',
          distance: 19,
          additionalProperties: {},
        },
        {
          id: 'bank',
          name: 'Bank',
          distance: 19,
          additionalProperties: {},
        },
        {
          id: 'post_office',
          name: 'Post',
          distance: 378,
          additionalProperties: {},
        },
        {
          id: 'police',
          name: 'Polizei',
          distance: 169,
          additionalProperties: {},
        },
      ],
      additionalProperties: {},
    },
  ],
  additionalProperties: {},
};
